(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coffret"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    document.querySelectorAll('[data-section-type="lemust-coffret-composer"]').forEach(initSection);

    function initSection(root) {
      if (root._lemustCoffretInited) return;
      root._lemustCoffretInited = true;

      var ALLOW_DUP = root.dataset.allowDuplicates !== 'false';
      var REDIRECT = (root.dataset.successRedirect || 'stay').toLowerCase();
      var VARIANT_10 = root.dataset.variant10 || null;
      var VARIANT_16 = root.dataset.variant16 || null;
      var STORAGE_KEY = 'lemust-coffret-v2-' + (root.dataset.sectionId || 'default');

      // Refs DOM
      var stepSize   = root.querySelector('[data-step="size"]');
      var stepGamme  = root.querySelector('[data-step="gamme"]');
      var stepCompose= root.querySelector('[data-step="compose"]');
      var recap      = root.querySelector('[data-recap]');
      var recapSize  = root.querySelector('[data-recap-size]');
      var recapGamme = root.querySelector('[data-recap-gamme]');
      var editSize   = root.querySelector('[data-edit-size]');
      var editGamme  = root.querySelector('[data-edit-gamme]');

      var cards        = Array.from(root.querySelectorAll('[data-coffret-card]'));
      var picksList    = root.querySelector('[data-picked-list]');
      var pickedCountEl= root.querySelector('[data-picked-count]');
      var targetCountEl= root.querySelector('[data-target-count]');
      var progressFill = root.querySelector('[data-progress-fill]');
      var progressSts  = root.querySelector('[data-progress-status]');
      var sidebarTitle = root.querySelector('[data-sidebar-title]');
      var sidebarPrice = root.querySelector('[data-sidebar-price]');
      var mobFill      = root.querySelector('[data-mob-fill]');
      var mobCountEl   = root.querySelector('[data-mob-count]');
      var mobTargetEl  = root.querySelector('[data-mob-target]');
      var mobileBar    = root.querySelector('[data-mobile-bar]');
      var scrollBtn    = root.querySelector('[data-mob-scroll]');
      var addBtn       = root.querySelector('[data-coffret-add]');
      var ctaLabel     = root.querySelector('[data-cta-label]');
      var clearBtn     = root.querySelector('[data-coffret-clear]');
      var toast        = root.querySelector('[data-coffret-toast]');
      var modalEl      = root.querySelector('[data-modal]');
      var modalBody    = root.querySelector('[data-modal-body]');
      var modalData    = root.querySelector('[data-modal-data]');
      var filterBar    = root.querySelector('[data-filters]');
      var filterChipsC = root.querySelector('[data-filter-chips]');
      var emptyState   = root.querySelector('[data-filters-empty]');
      var filterCount  = root.querySelector('[data-filter-count]');
      var filterCountV = root.querySelector('[data-filter-count-value]');
      var filterCountP = root.querySelector('[data-filter-count-plural]');
      var filterReset  = root.querySelector('[data-filter-reset]');

      // ---- Etat ----
      var state = {
        size: null,       // 10 ou 16
        gamme: null,      // 'deluxe' ou 'premium'
        composition: []   // [productId, productId, ...]
      };
      var typeFilters = new Set();

      // ---- Persistance ----
      function save() {
        try {
          if (!state.size && !state.gamme && state.composition.length === 0) {
            localStorage.removeItem(STORAGE_KEY);
          } else {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
          }
        } catch (e) {}
      }
      function restore() {
        try {
          var raw = localStorage.getItem(STORAGE_KEY);
          if (!raw) return;
          var data = JSON.parse(raw);
          if (data && typeof data === 'object') {
            if (data.size === 10 || data.size === 16) state.size = data.size;
            if (data.gamme === 'deluxe' || data.gamme === 'premium') state.gamme = data.gamme;
            if (Array.isArray(data.composition)) state.composition = data.composition.slice(0, targetCount());
          }
        } catch (e) {}
      }

      // ---- Helpers ----
      function targetCount() { return state.size || 10; }
      function currentVariant() {
        if (state.size === 16) return VARIANT_16;
        if (state.size === 10) return VARIANT_10;
        return null;
      }
      function currentCoffretName() {
        var choice = root.querySelector('.lemust-coffret-choice[data-size="' + state.size + '"] .lemust-coffret-choice__title');
        return choice ? choice.textContent.trim() : 'Coffret Découverte';
      }
      function currentGammeName() {
        var choice = root.querySelector('.lemust-coffret-choice[data-gamme="' + state.gamme + '"] .lemust-coffret-choice__title');
        return choice ? choice.textContent.trim() : (state.gamme === 'deluxe' ? 'Gamme Deluxe' : 'Gamme Premium');
      }
      function currentPrice() {
        var choice = root.querySelector('.lemust-coffret-choice[data-size="' + state.size + '"] .lemust-coffret-choice__price');
        return choice ? choice.textContent.trim() : '';
      }
      function countInComp(pid) {
        var c = 0;
        for (var i = 0; i < state.composition.length; i++) if (state.composition[i] === pid) c++;
        return c;
      }
      function cardByPid(pid) {
        for (var i = 0; i < cards.length; i++) if (cards[i].dataset.productId === pid) return cards[i];
        return null;
      }
      function showToast(msg, isError) {
        if (!toast) return;
        toast.textContent = msg;
        toast.classList.toggle('is-error', !!isError);
        toast.hidden = false;
        clearTimeout(showToast._t);
        showToast._t = setTimeout(function () { toast.hidden = true; }, 3200);
      }
      function typeKeywordFor(raw) {
        if (!raw) return '';
        var s = raw.toLowerCase();
        if (s.indexOf('confiture') !== -1) return 'Confitures';
        if (s.indexOf('miel') !== -1)      return 'Miel';
        if (s.indexOf('condiment') !== -1) return 'Condiments';
        if (s.indexOf('douceur') !== -1)   return 'Douceurs';
        if (s.indexOf('plateau') !== -1)   return 'Plateaux';
        var first = raw.trim().split(/\s+/)[0] || '';
        return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
      }
      function stockTone(str) {
        var s = (str || '').toLowerCase();
        if (!s) return null;
        if (s.indexOf('rupture') !== -1 || s.indexOf('épuisé') !== -1 ||
            s.indexOf('epuise') !== -1 || s.indexOf('out') !== -1) return 'out';
        if (s.indexOf('bientôt') !== -1 || s.indexOf('bientot') !== -1 ||
            s.indexOf('quelques') !== -1 || s.indexOf('faible') !== -1 ||
            s.indexOf('low') !== -1 || s.indexOf('limité') !== -1) return 'low';
        return 'in';
      }
      function applyStockBadges() {
        cards.forEach(function (card) {
          var badge = card.querySelector('[data-stock-badge]');
          if (!badge) return;
          var tone = stockTone(card.dataset.stockStatus);
          if (tone) badge.setAttribute('data-stock-tone', tone);
          if (tone === 'out') card.classList.add('is-out-of-stock');
        });
      }

      // ---- Actions state ----
      function pickSize(size) {
        var newSize = parseInt(size, 10);
        if (state.size && state.size !== newSize && state.composition.length > 0) {
          // Si on change de format et qu'on a deja compose, tronque
          state.composition = state.composition.slice(0, newSize);
        }
        state.size = newSize;
        save();
        renderSteps();
        renderCompose();
      }
      function pickGamme(gamme) {
        if (state.gamme && state.gamme !== gamme && state.composition.length > 0) {
          if (!confirm('Changer de gamme videra votre composition actuelle. Continuer ?')) return;
          state.composition = [];
        }
        state.gamme = gamme;
        save();
        renderSteps();
        renderCompose();
      }
      function addPick(pid) {
        if (!state.size || !state.gamme) {
          showToast('Choisissez d\'abord un format et une gamme', true);
          return;
        }
        if (state.composition.length >= targetCount()) {
          showToast('Coffret complet — retirez un pot avant d\'ajouter', true);
          return;
        }
        if (!ALLOW_DUP && state.composition.indexOf(pid) !== -1) {
          showToast('Ce produit est déjà dans votre coffret', true);
          return;
        }
        state.composition.push(pid);
        save();
        renderCompose();
      }
      function removeOne(pid) {
        var idx = state.composition.lastIndexOf(pid);
        if (idx !== -1) state.composition.splice(idx, 1);
        save();
        renderCompose();
      }
      function clearAll() {
        state.composition = [];
        save();
        renderCompose();
      }

      // ---- Rendu des etapes (visibilite + choix actifs) ----
      function renderSteps() {
        // Etape 1 : toujours visible tant que non choisi
        var sizeChoices = root.querySelectorAll('[data-size]');
        sizeChoices.forEach(function (btn) {
          btn.classList.toggle('is-active', parseInt(btn.dataset.size, 10) === state.size);
        });

        // Etape 2 : visible si size choisi
        if (state.size) {
          stepGamme.hidden = false;
          stepGamme.removeAttribute('data-locked');
        } else {
          stepGamme.hidden = true;
          stepGamme.setAttribute('data-locked', '');
        }
        var gammeChoices = root.querySelectorAll('[data-gamme]');
        gammeChoices.forEach(function (btn) {
          btn.classList.toggle('is-active', btn.dataset.gamme === state.gamme);
        });

        // Etape 3 : visible si size + gamme choisis
        if (state.size && state.gamme) {
          stepCompose.hidden = false;
          stepCompose.removeAttribute('data-locked');
          // Cache les 2 premieres etapes une fois valides + recap
          stepSize.hidden = true;
          stepGamme.hidden = true;
          if (recap) recap.hidden = false;
          if (recapSize)  recapSize.textContent = state.size + ' pots — ' + currentPrice();
          if (recapGamme) recapGamme.textContent = currentGammeName();
        } else {
          stepCompose.hidden = true;
          stepCompose.setAttribute('data-locked', '');
          stepSize.hidden = false;
          if (recap) recap.hidden = true;
        }
      }

      // ---- Rendu compose ----
      function renderCompose() {
        var target = targetCount();
        var count = state.composition.length;

        // Cache/affiche les cards selon la gamme choisie
        cards.forEach(function (card) {
          var gammeMatch = card.dataset.gamme === state.gamme;
          card.hidden = !gammeMatch;
          var pid = card.dataset.productId;
          var n = countInComp(pid);
          var countEl = card.querySelector('[data-card-count]');
          if (countEl) countEl.textContent = '×' + n;
          card.classList.toggle('is-selected', n > 0);
          var full = count >= target && n === 0;
          var soldOut = card.classList.contains('is-out-of-stock');
          card.classList.toggle('is-disabled', full || soldOut);
        });

        // Recompute filtres (les chips comptent uniquement les visibles selon gamme)
        rebuildFilterChips();
        applyFilters();

        // Sidebar
        if (sidebarTitle) sidebarTitle.textContent = currentCoffretName();
        if (sidebarPrice) sidebarPrice.textContent = currentPrice();
        if (pickedCountEl) pickedCountEl.textContent = count;
        if (targetCountEl) targetCountEl.textContent = target;
        if (mobTargetEl)   mobTargetEl.textContent = target;
        if (mobCountEl)    mobCountEl.textContent = count;
        var pct = Math.min(100, Math.round((count / target) * 100));
        if (progressFill) {
          progressFill.style.width = pct + '%';
          progressFill.classList.toggle('is-complete', count >= target);
        }
        if (mobFill) mobFill.style.width = pct + '%';
        if (progressSts) {
          progressSts.textContent = count === 0 ? 'À composer' :
                                    count < target ? 'En cours' : '✓ Prêt';
          progressSts.classList.toggle('is-complete', count >= target);
        }
        // Liste
        if (picksList) {
          picksList.innerHTML = '';
          if (count === 0) {
            var li = document.createElement('li');
            li.className = 'lemust-coffret-sidebar__empty';
            li.textContent = 'Cliquez sur un produit pour l\'ajouter à votre coffret.';
            picksList.appendChild(li);
          } else {
            var grouped = {}, order = [];
            state.composition.forEach(function (pid) {
              if (grouped[pid] == null) { grouped[pid] = 0; order.push(pid); }
              grouped[pid]++;
            });
            order.forEach(function (pid) {
              var c = cardByPid(pid);
              var name = c ? c.dataset.productTitle : pid;
              var li = document.createElement('li');
              li.innerHTML =
                '<span class="lemust-coffret-sidebar__item-qty">×' + grouped[pid] + '</span>' +
                '<span class="lemust-coffret-sidebar__item-name">' + escapeHtml(name) + '</span>' +
                '<button type="button" class="lemust-coffret-sidebar__item-remove" data-remove-pid="' + pid + '" aria-label="Retirer">' +
                  '<svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"/></svg>' +
                '</button>';
              picksList.appendChild(li);
            });
            picksList.querySelectorAll('[data-remove-pid]').forEach(function (btn) {
              btn.addEventListener('click', function () { removeOne(btn.dataset.removePid); });
            });
          }
        }
        // CTA
        if (addBtn) {
          var ready = count >= target;
          addBtn.disabled = !ready;
          addBtn.classList.toggle('is-ready', ready);
          if (ctaLabel) {
            ctaLabel.textContent = ready ? 'Ajouter au panier' :
              'Sélectionnez encore ' + (target - count) + ' pot' + (target - count > 1 ? 's' : '');
          }
        }
        if (clearBtn) clearBtn.hidden = count === 0;
        // Mobile bar
        if (mobileBar) {
          var has = count > 0;
          if (has) {
            mobileBar.hidden = false;
            requestAnimationFrame(function () { mobileBar.classList.add('is-visible'); });
          } else {
            mobileBar.classList.remove('is-visible');
            setTimeout(function () {
              if (!mobileBar.classList.contains('is-visible')) mobileBar.hidden = true;
            }, 350);
          }
        }
      }

      // ---- Filtres (par type dans la gamme active) ----
      function rebuildFilterChips() {
        if (!filterBar || !filterChipsC) return;
        filterChipsC.innerHTML = '';
        typeFilters.clear();
        if (!state.gamme) { filterBar.hidden = true; return; }
        var typesMap = new Map();
        cards.forEach(function (card) {
          if (card.dataset.gamme !== state.gamme) return;
          var kw = typeKeywordFor(card.dataset.typeProduit);
          if (kw) typesMap.set(kw, (typesMap.get(kw) || 0) + 1);
        });
        if (typesMap.size === 0) { filterBar.hidden = true; return; }
        filterBar.hidden = false;
        var priority = ['Confitures', 'Miel', 'Condiments', 'Douceurs', 'Plateaux'];
        var keys = Array.from(typesMap.keys()).sort(function (a, b) {
          var ia = priority.indexOf(a), ib = priority.indexOf(b);
          if (ia !== -1 && ib === -1) return -1;
          if (ib !== -1 && ia === -1) return 1;
          if (ia !== -1 && ib !== -1) return ia - ib;
          return a.localeCompare(b, 'fr');
        });
        keys.forEach(function (k) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'lemust-filter-chip';
          chip.innerHTML = escapeHtml(k) + ' <span class="lemust-filter-chip__count">' + typesMap.get(k) + '</span>';
          chip.addEventListener('click', function () {
            if (typeFilters.has(k)) { typeFilters.delete(k); chip.classList.remove('is-active'); }
            else { typeFilters.add(k); chip.classList.add('is-active'); }
            applyFilters();
          });
          filterChipsC.appendChild(chip);
        });
      }
      function applyFilters() {
        var active = typeFilters.size > 0;
        var visible = 0;
        cards.forEach(function (card) {
          if (card.dataset.gamme !== state.gamme) return;
          var kw = typeKeywordFor(card.dataset.typeProduit);
          var pass = !active || typeFilters.has(kw);
          if (pass) { card.style.display = ''; visible++; }
          else { card.style.display = 'none'; }
        });
        if (filterCount)  filterCount.hidden = !active;
        if (filterCountV) filterCountV.textContent = visible;
        if (filterCountP) filterCountP.textContent = visible > 1 ? 's' : '';
        if (filterReset)  filterReset.hidden = !active;
        if (emptyState)   emptyState.hidden = !(active && visible === 0);
      }
      function resetFilters() {
        typeFilters.clear();
        if (filterChipsC) {
          filterChipsC.querySelectorAll('.lemust-filter-chip.is-active').forEach(function (c) {
            c.classList.remove('is-active');
          });
        }
        applyFilters();
      }
      if (filterReset) filterReset.addEventListener('click', resetFilters);

      // ---- Modale info produit ----
      function openModal(pid) {
        if (!modalEl || !modalBody || !modalData) return;
        var tpl = modalData.querySelector('template[data-product-id="' + pid + '"]');
        if (!tpl) return;
        modalBody.innerHTML = '';
        modalBody.appendChild(tpl.content.cloneNode(true));
        var picksLbl = modalBody.querySelector('[data-modal-picks]');
        var addBtnM  = modalBody.querySelector('[data-modal-add-to-coffret]');
        function refreshModal() {
          if (picksLbl) picksLbl.textContent = countInComp(pid) + ' dans le coffret';
        }
        refreshModal();
        if (addBtnM) {
          addBtnM.addEventListener('click', function () {
            addPick(pid);
            refreshModal();
          });
        }
        modalEl.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      function closeModal() {
        if (!modalEl) return;
        modalEl.hidden = true;
        document.body.style.overflow = '';
      }
      if (modalEl) {
        modalEl.querySelectorAll('[data-modal-close]').forEach(function (el) {
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modalEl.hidden) closeModal();
        });
      }

      // ---- Wire cards ----
      cards.forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('[data-coffret-info]')) {
            e.preventDefault();
            openModal(card.dataset.productId);
            return;
          }
          if (card.classList.contains('is-disabled') && !card.classList.contains('is-selected')) return;
          addPick(card.dataset.productId);
        });
      });

      // ---- Wire steps ----
      root.querySelectorAll('[data-size]').forEach(function (btn) {
        btn.addEventListener('click', function () { pickSize(btn.dataset.size); });
      });
      root.querySelectorAll('[data-gamme]').forEach(function (btn) {
        btn.addEventListener('click', function () { pickGamme(btn.dataset.gamme); });
      });
      function goBackToSize() {
        stepSize.hidden = false;
        stepSize.removeAttribute('data-locked');
        stepGamme.hidden = true;
        stepCompose.hidden = true;
        if (recap) recap.hidden = true;
        stepSize.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      function goBackToGamme() {
        stepSize.hidden = true;
        stepGamme.hidden = false;
        stepGamme.removeAttribute('data-locked');
        stepCompose.hidden = true;
        if (recap) recap.hidden = true;
        stepGamme.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (editSize)  editSize.addEventListener('click', goBackToSize);
      if (editGamme) editGamme.addEventListener('click', goBackToGamme);

      // Boutons "retour" directement dans les etapes 2 et 3
      var backToSizeBtns = root.querySelectorAll('[data-back-to-size], [data-back-to-size-from-gamme]');
      backToSizeBtns.forEach(function (btn) { btn.addEventListener('click', goBackToSize); });
      var backToGammeBtns = root.querySelectorAll('[data-back-to-gamme]');
      backToGammeBtns.forEach(function (btn) { btn.addEventListener('click', goBackToGamme); });

      // ---- Add to cart ----
      function handleAddToCart() {
        var variant = currentVariant();

        // Diagnostic clair si la variante n'est pas detectee
        if (!variant) {
          console.error('[Lemust Coffret] Variante introuvable', {
            size: state.size,
            VARIANT_10: VARIANT_10,
            VARIANT_16: VARIANT_16,
            'root.dataset': root.dataset
          });
          showToast('Erreur : variante coffret non configurée. Vérifiez que le produit a bien 2 variantes avec « 10 » et « 16 » dans le titre.', true);
          return;
        }
        if (state.composition.length < targetCount()) {
          showToast('Sélectionnez encore ' + (targetCount() - state.composition.length) + ' pot(s)', true);
          return;
        }

        var props = {};
        props['Gamme'] = currentGammeName();
        state.composition.forEach(function (pid, i) {
          var c = cardByPid(pid);
          props['Pot ' + (i + 1)] = c ? c.dataset.productTitle : pid;
        });
        var grouped = {}, order = [];
        state.composition.forEach(function (pid) {
          if (grouped[pid] == null) { grouped[pid] = 0; order.push(pid); }
          grouped[pid]++;
        });
        var summary = order.map(function (pid) {
          var c = cardByPid(pid);
          var name = c ? c.dataset.productTitle : pid;
          return grouped[pid] + '× ' + name;
        }).join(' · ');
        props['Composition'] = summary;

        addBtn.disabled = true;
        var origLabel = ctaLabel ? ctaLabel.textContent : 'Ajouter au panier';
        if (ctaLabel) ctaLabel.textContent = 'Ajout en cours...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variant, 10),
            quantity: 1,
            properties: props
          })
        })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function () {
          if (REDIRECT === 'cart')     { window.location.href = '/cart'; return null; }
          if (REDIRECT === 'checkout') { window.location.href = '/checkout'; return null; }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          ['[data-cart-count]', '[data-cart-item-count]', '.cart-count', '.cart-count-bubble', '.cart-icon__bubble']
            .forEach(function (sel) {
              document.querySelectorAll(sel).forEach(function (el) {
                el.textContent = cart.item_count;
                if (cart.item_count > 0) el.hidden = false;
              });
            });
          ['cart:added', 'cart:updated', 'cart:refresh', 'cart-drawer:refresh'].forEach(function (evt) {
            document.dispatchEvent(new CustomEvent(evt, { detail: { cart: cart }, bubbles: true }));
          });
          var drawer = document.querySelector('cart-drawer, [is="cart-drawer"], #cart-drawer, .cart-drawer');
          if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (_) {} }
          showToast('✓ Coffret ajouté au panier');
          if (ctaLabel) ctaLabel.textContent = '✓ Ajouté';
          state.composition = [];
          save();
          setTimeout(function () {
            addBtn.disabled = false;
            if (ctaLabel) ctaLabel.textContent = origLabel;
            renderCompose();
          }, 2200);
        })
        .catch(function (err) {
          console.error('[Lemust Coffret] Add failed', err);
          showToast('Erreur, réessayez', true);
          if (ctaLabel) ctaLabel.textContent = origLabel;
          addBtn.disabled = false;
        });
      }

      if (addBtn) addBtn.addEventListener('click', handleAddToCart);
      if (clearBtn) clearBtn.addEventListener('click', clearAll);
      if (scrollBtn) {
        scrollBtn.addEventListener('click', function () {
          var target = root.querySelector('[data-sidebar]') || addBtn;
          if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      function escapeHtml(s) {
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }

      // ---- Init ----
      applyStockBadges();
      restore();
      renderSteps();
      renderCompose();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lemust-cart-vat"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Patterns VIES par pays (simplifies mais robustes)
    var EU_VAT_PATTERNS = {
      AT: /^ATU\d{8}$/,
      BE: /^BE[01]\d{9}$/,
      BG: /^BG\d{9,10}$/,
      CY: /^CY\d{8}[A-Z]$/,
      CZ: /^CZ\d{8,10}$/,
      DE: /^DE\d{9}$/,
      DK: /^DK\d{8}$/,
      EE: /^EE\d{9}$/,
      EL: /^EL\d{9}$/,
      ES: /^ES[A-Z\d]\d{7}[A-Z\d]$/,
      FI: /^FI\d{8}$/,
      FR: /^FR[A-HJ-NP-Z\d]{2}\d{9}$/,
      GB: /^GB(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/,
      HR: /^HR\d{11}$/,
      HU: /^HU\d{8}$/,
      IE: /^IE(\d{7}[A-W]|\d[A-W+*]\d{5}[A-W])[A-I]?$/,
      IT: /^IT\d{11}$/,
      LT: /^LT(\d{9}|\d{12})$/,
      LU: /^LU\d{8}$/,
      LV: /^LV\d{11}$/,
      MT: /^MT\d{8}$/,
      NL: /^NL\d{9}B\d{2}$/,
      PL: /^PL\d{10}$/,
      PT: /^PT\d{9}$/,
      RO: /^RO\d{2,10}$/,
      SE: /^SE\d{12}$/,
      SI: /^SI\d{8}$/,
      SK: /^SK\d{10}$/,
      XI: /^XI\d{9}$/  // Irlande du Nord (post-Brexit)
    };

    function cleanVat(raw) {
      return String(raw || '').toUpperCase().replace(/[\s.\-_]/g, '');
    }
    function validateVat(vat) {
      var s = cleanVat(vat);
      if (s.length === 0) return { state: 'empty' };
      if (s.length < 4)   return { state: 'invalid', reason: 'Numéro trop court' };
      var country = s.substring(0, 2);
      var pattern = EU_VAT_PATTERNS[country];
      if (!pattern)       return { state: 'invalid', reason: 'Code pays « ' + country + ' » non reconnu' };
      if (!pattern.test(s)) return { state: 'invalid', reason: 'Format ' + country + ' invalide (' + s.length + ' caractères)' };
      return { state: 'valid', clean: s, country: country };
    }

    document.querySelectorAll('[data-lemust-cart-vat]').forEach(initSection);

    function initSection(root) {
      if (root._lemustVatInited) return;
      root._lemustVatInited = true;

      var ATTR_NAME     = root.dataset.attributeName || 'VAT number';
      var BLOCK_CHECKOUT= root.dataset.blockCheckout !== 'false';
      var toggle  = root.querySelector('[data-vat-toggle]');
      var field   = root.querySelector('[data-vat-field]');
      var input   = root.querySelector('[data-vat-input]');
      var status  = root.querySelector('[data-vat-status]');
      var blocker = root.querySelector('[data-vat-blocker]');

      // Etat interne
      var lastState = { state: 'empty' };
      var saveTimeout = null;

      // ---- Init : recupere l'etat du panier ----
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.attributes) return;
          var savedVat = cart.attributes[ATTR_NAME] || cart.attributes['Numéro de TVA'] || '';
          var isBusiness = cart.attributes['Commande entreprise'] === 'oui' || !!savedVat;
          if (isBusiness && toggle) {
            toggle.checked = true;
            syncFieldVisibility();
          }
          if (savedVat && input) {
            input.value = savedVat;
            revalidate();
          }
        })
        .catch(function () { /* silencieux */ });

      // ---- Wire toggle ----
      function syncFieldVisibility() {
        if (toggle.checked) {
          field.removeAttribute('hidden');
          field.hidden = false;
        } else {
          field.setAttribute('hidden', '');
          field.hidden = true;
          // On efface aussi les attributs cart si la case est decochee
          saveToCart('', false);
          if (input) input.value = '';
          if (status) status.removeAttribute('data-tone');
          if (input) input.removeAttribute('data-state');
          if (blocker) blocker.hidden = true;
          lastState = { state: 'empty' };
        }
      }
      if (toggle) {
        toggle.addEventListener('change', syncFieldVisibility);
      }

      // ---- Auto-format + validation en temps reel ----
      function revalidate() {
        if (!input) return;
        var raw = input.value;
        var cleaned = cleanVat(raw);
        // Reformate le champ en direct (uppercase + strip)
        if (cleaned !== raw) {
          var pos = input.selectionStart;
          input.value = cleaned;
          try { input.setSelectionRange(pos, pos); } catch (_) {}
        }
        var res = validateVat(cleaned);
        lastState = res;
        if (res.state === 'empty') {
          input.removeAttribute('data-state');
          if (status) { status.removeAttribute('data-tone'); status.textContent = ''; }
          if (blocker) blocker.hidden = true;
        } else if (res.state === 'valid') {
          input.setAttribute('data-state', 'valid');
          if (status) { status.setAttribute('data-tone', 'valid'); status.textContent = '✓'; }
          if (blocker) blocker.hidden = true;
        } else {
          input.setAttribute('data-state', 'invalid');
          if (status) { status.setAttribute('data-tone', 'invalid'); status.textContent = '✗'; }
          if (blocker) {
            blocker.textContent = res.reason || 'Numéro de TVA invalide';
            blocker.hidden = false;
          }
        }
        // Debounce save
        clearTimeout(saveTimeout);
        saveTimeout = setTimeout(function () {
          if (res.state === 'valid') saveToCart(res.clean, true);
          else if (res.state === 'empty') saveToCart('', false);
          // Si invalide : on ne sauve pas, on attend une correction
        }, 500);
      }
      if (input) {
        input.addEventListener('input', revalidate);
        input.addEventListener('blur', revalidate);
      }

      // ---- Sauvegarde vers Shopify cart attributes ----
      function saveToCart(vat, isBusiness) {
        var attrs = {};
        attrs[ATTR_NAME] = vat || '';
        attrs['Commande entreprise'] = isBusiness ? 'oui' : '';
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).catch(function (e) {
          console.warn('[Lemust Cart VAT] Save failed', e);
        });
      }

      // ---- Blocage du checkout si case cochee + TVA invalide ----
      if (BLOCK_CHECKOUT) {
        var checkoutSelectors = [
          'button[name="checkout"]',
          'input[name="checkout"]',
          'a[href="/checkout"]',
          'a[href^="/checkout"]',
          '[data-checkout-button]',
          '.cart__checkout-button',
          '.cart-item__checkout-button',
          '#checkout',
          '.cart__ctas button[type="submit"]'
        ];
        function shouldBlock() {
          if (!toggle || !toggle.checked) return false;
          return lastState.state !== 'valid';
        }
        function blockHandler(e) {
          if (!shouldBlock()) return;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation && e.stopImmediatePropagation();
          // Focus + scroll vers le champ
          if (input) {
            input.focus();
            input.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          if (blocker) blocker.hidden = false;
          // Toast global
          showToast(lastState.reason || 'Numéro de TVA invalide — corrigez avant de continuer');
        }
        // Attache sur tous les selecteurs candidats
        checkoutSelectors.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.addEventListener('click', blockHandler, true);
          });
        });
        // Attache aussi sur le submit du form panier
        document.querySelectorAll('form[action^="/cart"], form[action$="/cart"]').forEach(function (form) {
          form.addEventListener('submit', function (e) {
            if (!shouldBlock()) return;
            var target = e.submitter;
            if (target && (target.name === 'checkout' || target.value === 'checkout')) {
              blockHandler(e);
            }
          }, true);
        });
      }

      function showToast(msg) {
        var el = document.createElement('div');
        el.className = 'lemust-cart-vat-toast';
        el.textContent = msg;
        document.body.appendChild(el);
        setTimeout(function () {
          el.style.opacity = '0';
          el.style.transition = 'opacity 0.25s';
          setTimeout(function () { el.remove(); }, 300);
        }, 3500);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lemust-catalog-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    // Formateur monetaire aligne sur le format Shopify de la boutique (shop.money_format),
    // pour que les montants JS soient identiques a ceux rendus par Liquid.
    // Doit etre declare AVANT l'init des sections.
    function makeMoneyFormatter(format) {
      format = format || '{{amount}} €';
      function group(str, sep) { return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
      return function (cents) {
        var v = (parseInt(cents, 10) || 0) / 100;
        var s;
        if (format.indexOf('amount_no_decimals_with_comma_separator') !== -1)      s = group(String(Math.round(v)), '.');
        else if (format.indexOf('amount_no_decimals_with_space_separator') !== -1) s = group(String(Math.round(v)), ' ');
        else if (format.indexOf('amount_with_comma_separator') !== -1)             s = group(v.toFixed(2).split('.')[0], '.') + ',' + v.toFixed(2).split('.')[1];
        else if (format.indexOf('amount_with_space_separator') !== -1)             s = group(v.toFixed(2).split('.')[0], ' ') + ',' + v.toFixed(2).split('.')[1];
        else if (format.indexOf('amount_with_apostrophe_separator') !== -1)        s = group(v.toFixed(2).split('.')[0], "'") + '.' + v.toFixed(2).split('.')[1];
        else if (format.indexOf('amount_no_decimals') !== -1)                      s = group(String(Math.round(v)), ',');
        else                                                                        s = group(v.toFixed(2).split('.')[0], ',') + '.' + v.toFixed(2).split('.')[1];
        return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]*>/g, '');
      };
    }

    document.querySelectorAll('[data-section-type="lemust-catalog-grid"]').forEach(initSection);

    // ------------------------------------------------------------------
    // Panier commun avec /pages/commander : on passe par le panier Shopify
    // (/cart/add.js). Les lignes s'additionnent a celles deja presentes,
    // donc un client peut melanger les deux pages sans rien perdre.
    // ------------------------------------------------------------------
    function refreshCartUi() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var selectors = [
            '[data-cart-count]', '[data-cart-item-count]', '.cart-count',
            '.cart-count-bubble', '.cart-icon__bubble', '.js-cart-count'
          ];
          selectors.forEach(function (sel) {
            document.querySelectorAll(sel).forEach(function (el) {
              el.textContent = cart.item_count;
              if (el.dataset) el.dataset.count = cart.item_count;
              if (cart.item_count > 0) el.hidden = false;
            });
          });
          ['cart:added', 'cart:updated', 'cart:refresh', 'cart:change', 'cart-drawer:refresh'].forEach(function (evt) {
            document.dispatchEvent(new CustomEvent(evt, { detail: { cart: cart }, bubbles: true }));
          });
          return cart;
        })
        .catch(function (e) { console.warn('[Lemust] refresh panier', e); });
    }

    function initSection(root) {
      if (root._lemustCatalogInit) return;
      root._lemustCatalogInit = true;

      var modalEl = root.querySelector('[data-modal]');
      var modalBody = root.querySelector('[data-modal-body]');
      var modalData = root.querySelector('[data-modal-data]');
      var openDrawer = root.dataset.openDrawer === 'true';
      var fmtMoney = makeMoneyFormatter(root.dataset.moneyFormat);

      // ---------- Commande directe depuis la carte ----------
      root.querySelectorAll('.lemust-catalog-card').forEach(initCard);

      function cardState(card) {
        var large = card.dataset.format === 'large' && card.dataset.single !== '1';
        return {
          variantId: large ? card.dataset.vLarge : card.dataset.vSmall,
          price: parseInt(large ? card.dataset.pLarge : card.dataset.pSmall, 10) || 0,
          units: parseInt(large ? card.dataset.uLarge : card.dataset.uSmall, 10) || 1,
          available: (large ? card.dataset.availLarge : card.dataset.availSmall) === '1'
        };
      }

      function readQty(card) {
        var input = card.querySelector('[data-qty]');
        var q = parseInt(input && input.value, 10);
        if (!q || q < 1) q = 1;
        if (q > 999) q = 999;
        if (input) input.value = q;
        return q;
      }

      function renderCard(card) {
        var st = cardState(card);
        var addBtn = card.querySelector('[data-add]');
        var labelEl = card.querySelector('[data-add-label]');
        var totalEl = card.querySelector('[data-add-total]');
        var lineEl = card.querySelector('[data-line]');
        var qty = readQty(card);
        var total = st.price * qty;

        if (totalEl) totalEl.textContent = fmtMoney(total);
        if (lineEl) {
          lineEl.textContent = qty > 1
            ? qty + ' cartons · ' + (qty * st.units) + ' pots · ' + fmtMoney(total) + ' HT'
            : (st.units + ' pots · ' + fmtMoney(st.price) + ' HT');
        }
        if (addBtn && !addBtn.dataset.busy) {
          addBtn.disabled = !st.available;
          if (labelEl && !addBtn.classList.contains('is-done') && !addBtn.classList.contains('is-error')) {
            labelEl.textContent = st.available ? 'Ajouter' : 'Indisponible';
          }
          if (totalEl) totalEl.hidden = !st.available;
        }
      }

      function selectFormat(card, format) {
        card.dataset.format = format;
        card.querySelectorAll('[data-format-btn]').forEach(function (b) {
          var on = b.dataset.formatBtn === format;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        renderCard(card);
      }

      function initCard(card) {
        card.querySelectorAll('[data-format-btn]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            selectFormat(card, btn.dataset.formatBtn);
          });
        });
        // Si le format pre-selectionne est epuise, bascule sur l'autre
        var active = card.querySelector('[data-format-btn].is-active');
        if (active && active.disabled) {
          var alt = card.querySelector('[data-format-btn]:not([disabled])');
          if (alt) selectFormat(card, alt.dataset.formatBtn);
        }

        card.querySelectorAll('[data-qty-step]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var input = card.querySelector('[data-qty]');
            if (!input) return;
            var q = (parseInt(input.value, 10) || 1) + (parseInt(btn.dataset.qtyStep, 10) || 0);
            input.value = q < 1 ? 1 : q;
            renderCard(card);
          });
        });

        var qtyInput = card.querySelector('[data-qty]');
        if (qtyInput) qtyInput.addEventListener('input', function () { renderCard(card); });

        var addBtn = card.querySelector('[data-add]');
        if (addBtn) addBtn.addEventListener('click', function () { addToCart(card, addBtn); });

        renderCard(card);
      }

      function addToCart(card, btn) {
        var st = cardState(card);
        if (!st.variantId || !st.available || btn.dataset.busy) return;
        var qty = readQty(card);

        var labelEl = btn.querySelector('[data-add-label]');
        var totalEl = btn.querySelector('[data-add-total]');
        function setLabel(txt, showTotal) {
          if (labelEl) labelEl.textContent = txt; else btn.textContent = txt;
          if (totalEl) totalEl.hidden = !showTotal;
        }

        btn.dataset.busy = '1';
        btn.disabled = true;
        btn.classList.remove('is-done', 'is-error');
        setLabel('Ajout…', false);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(st.variantId, 10), quantity: qty }] })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'HTTP ' + res.status); });
            return res.json();
          })
          .then(function () { return refreshCartUi(); })
          .then(function (cart) {
            btn.classList.add('is-done');
            setLabel('✓ Ajouté', false);
            var lineEl = card.querySelector('[data-line]');
            if (lineEl && cart) {
              lineEl.textContent = 'Panier : ' + cart.item_count + ' carton' + (cart.item_count > 1 ? 's' : '') +
                ' — ' + fmtMoney(cart.total_price) + ' HT';
            }
            if (openDrawer) {
              var drawer = document.querySelector('cart-drawer, [is="cart-drawer"], #cart-drawer, .cart-drawer, [data-cart-drawer]');
              if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (_) {} }
            }
          })
          .catch(function (err) {
            console.error('[Lemust] Ajout panier echoue', err);
            btn.classList.add('is-error');
            setLabel(err && err.message ? 'Erreur — ' + err.message : 'Erreur, réessayer', false);
          })
          .then(function () {
            setTimeout(function () {
              delete btn.dataset.busy;
              btn.classList.remove('is-done', 'is-error');
              renderCard(card);
            }, 2200);
          });
      }

      // ---------- Fiche produit ----------
      // Ouvre la modale au clic sur le bouton "i" ou sur le visuel
      root.querySelectorAll('[data-info-btn]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var card = btn.closest('[data-product-id]');
          if (!card) return;
          openModal(card.dataset.productId);
        });
      });
      root.querySelectorAll('[data-open-info]').forEach(function (hero) {
        hero.addEventListener('click', function (e) {
          if (e.target.closest('[data-info-btn]')) return;
          var card = hero.closest('[data-product-id]');
          if (card) openModal(card.dataset.productId);
        });
        hero.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          var card = hero.closest('[data-product-id]');
          if (card) openModal(card.dataset.productId);
        });
      });

      function openModal(pid) {
        if (!modalEl || !modalBody || !modalData) return;
        var tpl = modalData.querySelector('template[data-product-id="' + pid + '"]');
        if (!tpl) return;
        modalBody.innerHTML = '';
        modalBody.appendChild(tpl.content.cloneNode(true));
        modalEl.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      function closeModal() {
        if (!modalEl) return;
        modalEl.hidden = true;
        document.body.style.overflow = '';
      }
      if (modalEl) {
        modalEl.querySelectorAll('[data-modal-close]').forEach(function (el) {
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modalEl.hidden) closeModal();
        });
      }
    }

    // Sur /pages/commander : scroll + highlight de la ligne correspondant a l'ancre #product-XXX
    if (window.location.pathname.indexOf('/pages/commander') === 0 && window.location.hash.indexOf('#product-') === 0) {
      window.addEventListener('load', function () {
        setTimeout(function () {
          var pid = window.location.hash.replace('#product-', '');
          var target = document.querySelector('[data-row][data-product-id="' + pid + '"]');
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () {
            target.style.animation = 'lemust-highlight-flash 2s ease';
            target.addEventListener('animationend', function () { target.style.animation = ''; }, { once: true });
          }, 400);
        }, 500);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lemust-contact-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    document.querySelectorAll('[data-section-type="lemust-contact-hub"]').forEach(initSection);

    var EU_VAT = {
      AT:/^ATU\d{8}$/, BE:/^BE[01]\d{9}$/, BG:/^BG\d{9,10}$/, CY:/^CY\d{8}[A-Z]$/,
      CZ:/^CZ\d{8,10}$/, DE:/^DE\d{9}$/, DK:/^DK\d{8}$/, EE:/^EE\d{9}$/,
      EL:/^EL\d{9}$/, ES:/^ES[A-Z\d]\d{7}[A-Z\d]$/, FI:/^FI\d{8}$/,
      FR:/^FR[A-HJ-NP-Z\d]{2}\d{9}$/, GB:/^GB(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/,
      HR:/^HR\d{11}$/, HU:/^HU\d{8}$/, IE:/^IE(\d{7}[A-W]|\d[A-W+*]\d{5}[A-W])[A-I]?$/,
      IT:/^IT\d{11}$/, LT:/^LT(\d{9}|\d{12})$/, LU:/^LU\d{8}$/, LV:/^LV\d{11}$/,
      MT:/^MT\d{8}$/, NL:/^NL\d{9}B\d{2}$/, PL:/^PL\d{10}$/, PT:/^PT\d{9}$/,
      RO:/^RO\d{2,10}$/, SE:/^SE\d{12}$/, SI:/^SI\d{8}$/, SK:/^SK\d{10}$/,
      XI:/^XI\d{9}$/
    };
    function cleanVat(v) { return String(v || '').toUpperCase().replace(/[\s.\-_]/g, ''); }
    function validateVat(v) {
      var s = cleanVat(v);
      if (s.length < 4) return { ok: false, reason: 'Trop court' };
      var c = s.substring(0, 2);
      if (!EU_VAT[c]) return { ok: false, reason: 'Code pays ' + c + ' inconnu' };
      if (!EU_VAT[c].test(s)) return { ok: false, reason: 'Format ' + c + ' invalide' };
      return { ok: true, clean: s };
    }

    function initSection(root) {
      if (root._lemustContactInit) return;
      root._lemustContactInit = true;

      var STORAGE_KEY = 'lemust-contact-v1-' + (root.dataset.sectionId || 'x');
      var hub       = root.querySelector('[data-hub]');
      var msgWrap   = root.querySelector('[data-form="message"]');
      var quoteWrap = root.querySelector('[data-form="quote"]');
      var msgForm   = root.querySelector('[data-message-form]');
      var quoteForm = root.querySelector('[data-quote-form]');
      var msgStatus = root.querySelector('[data-message-status]');
      var quoteStatus = root.querySelector('[data-quote-status]');

      // Hub navigation - on force explicitement l'etat des DEUX formulaires
      root.querySelectorAll('[data-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var m = btn.dataset.mode;
          hub.hidden = true;
          msgWrap.hidden = (m !== 'message');
          quoteWrap.hidden = (m !== 'quote');
          window.scrollTo({ top: root.offsetTop - 40, behavior: 'smooth' });
        });
      });
      root.querySelectorAll('[data-back-hub]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          hub.hidden = false;
          msgWrap.hidden = true;
          quoteWrap.hidden = true;
          window.scrollTo({ top: root.offsetTop - 40, behavior: 'smooth' });
        });
      });

      // Success screen (reutilisable pour les 2 paths)
      function showSuccessScreen(wrap, title, desc, delay) {
        var panel = wrap.querySelector('.lemust-contact-panel');
        if (!panel) return;
        var back = wrap.querySelector('[data-back-hub]');
        if (back) back.style.display = 'none';
        panel.innerHTML =
          '<div class="lemust-success">' +
            '<span class="lemust-success__icon" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" width="42" height="42"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>' +
            '</span>' +
            '<h2 class="lemust-success__title">' + escapeHtml(title) + '</h2>' +
            '<p class="lemust-success__desc">' + escapeHtml(desc) + '</p>' +
            '<span class="lemust-success__meta">' +
              '<svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>' +
              'Réponse sous ' + delay +
            '</span>' +
            '<div class="lemust-success__actions">' +
              '<button type="button" class="button" data-success-home>Retour à l\'accueil</button>' +
            '</div>' +
          '</div>';
        var homeBtn = panel.querySelector('[data-success-home]');
        if (homeBtn) homeBtn.addEventListener('click', function () {
          window.location.href = '/';
        });
        wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // ---- PATH A : Message simple ----
      if (msgForm) {
        msgForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = msgForm.querySelector('[type="submit"]');
          btn.disabled = true;
          var orig = btn.textContent;
          btn.textContent = 'Envoi…';
          if (msgStatus) { msgStatus.hidden = true; msgStatus.className = 'lemust-contact-form__status'; }
          var fd = new FormData(msgForm);
          fetch(msgForm.getAttribute('action'), { method: 'POST', body: fd, headers: { 'Accept': 'text/html' } })
            .then(function (r) {
              if (r.ok || r.status === 302 || (r.status >= 200 && r.status < 400)) {
                showSuccessScreen(msgWrap, 'Message envoyé', 'Merci, votre message est bien parti. Notre équipe vous répondra personnellement dans les meilleurs délais.', '24h ouvrées');
              } else throw new Error('HTTP ' + r.status);
            })
            .catch(function () {
              if (msgStatus) { msgStatus.hidden = false; msgStatus.classList.add('is-error'); msgStatus.textContent = 'Une erreur est survenue. Réessayez.'; }
              btn.disabled = false; btn.textContent = orig;
            });
        });
      }

      // ---- PATH B : Wizard ----
      if (!quoteForm) return;
      var STEPS = quoteForm.querySelectorAll('[data-step]');
      var TOTAL = STEPS.length;
      var current = 1;
      var state = {};

      var progressSteps = root.querySelectorAll('[data-goto-step]');
      var progressFill  = root.querySelector('[data-wizard-fill]');
      var btnPrev       = root.querySelector('[data-wizard-prev]');
      var btnNext       = root.querySelector('[data-wizard-next]');
      var btnSubmit     = root.querySelector('[data-wizard-submit]');
      var recapBody     = root.querySelector('[data-recap-body]');
      var hiddenBody    = root.querySelector('[data-hidden-body]');

      function restore() {
        try {
          var raw = localStorage.getItem(STORAGE_KEY);
          if (!raw) return;
          state = JSON.parse(raw) || {};
          // Applique aux cards
          quoteForm.querySelectorAll('[data-cards]').forEach(function (group) {
            var name = group.dataset.name;
            var isMulti = group.hasAttribute('data-multi');
            var val = state[name];
            if (!val) return;
            var values = isMulti ? val.split(', ') : [val];
            group.querySelectorAll('.lemust-wizard-card').forEach(function (c) {
              if (values.indexOf(c.dataset.value) !== -1) c.classList.add('is-active');
            });
            var hidden = group.parentElement.querySelector('[data-hidden]');
            if (hidden) hidden.value = val;
          });
          // Applique aux inputs
          quoteForm.querySelectorAll('[data-name]').forEach(function (input) {
            if (input.tagName === 'BUTTON' || input.type === 'checkbox') return;
            if (input.hasAttribute('data-cards')) return;
            var val = state[input.dataset.name];
            if (val != null) input.value = val;
          });
          // Consent
          var consentInput = quoteForm.querySelector('input[type="checkbox"][data-name="consent"]');
          if (consentInput && state.consent) consentInput.checked = true;
        } catch (e) {}
      }
      function save() {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
      }
      function clearStorage() {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      }

      // Wire cards
      quoteForm.querySelectorAll('[data-cards]').forEach(function (group) {
        var name = group.dataset.name;
        var isMulti = group.hasAttribute('data-multi');
        var hidden = group.parentElement.querySelector('[data-hidden]');
        group.querySelectorAll('.lemust-wizard-card').forEach(function (card) {
          card.addEventListener('click', function () {
            var isExclusive = card.hasAttribute('data-exclusive');
            if (isMulti) {
              if (isExclusive) {
                // Clic sur "Peu importe" (exclusif) : desactive tous les autres
                var willActivate = !card.classList.contains('is-active');
                group.querySelectorAll('.lemust-wizard-card').forEach(function (c) { c.classList.remove('is-active'); });
                if (willActivate) card.classList.add('is-active');
              } else {
                // Clic sur un autre : desactive l'exclusif
                group.querySelectorAll('.lemust-wizard-card[data-exclusive]').forEach(function (c) { c.classList.remove('is-active'); });
                card.classList.toggle('is-active');
              }
            } else {
              group.querySelectorAll('.lemust-wizard-card').forEach(function (c) { c.classList.remove('is-active'); });
              card.classList.add('is-active');
            }
            var values = [];
            group.querySelectorAll('.lemust-wizard-card.is-active').forEach(function (c) { values.push(c.dataset.value); });
            var v = values.join(', ');
            if (hidden) hidden.value = v;
            state[name] = v;
            save();
            // Retire l'invalide si le groupe reprend une valeur
            if (v) group.classList.remove('is-invalid');
            hideStepError();
          });
        });
      });

      // Wire slider (couverts par jour)
      function trancheFor(n) {
        var v = parseInt(n, 10) || 0;
        if (v < 50)    return 'Moins de 50';
        if (v < 200)   return '50 à 200';
        if (v < 500)   return '200 à 500';
        if (v <= 1000) return '500 à 1 000';
        return 'Plus de 1 000';
      }
      quoteForm.querySelectorAll('[data-slider]').forEach(function (wrap) {
        var input   = wrap.querySelector('[data-slider-input]');
        var range   = wrap.querySelector('[data-slider-range]');
        var tranche = wrap.querySelector('[data-slider-tranche]');
        var hidden  = wrap.parentElement.querySelector('[data-hidden]');
        function syncFromNumber(val) {
          var n = parseInt(val, 10) || 0;
          if (n < 0) n = 0;
          if (input && String(input.value) !== String(n)) input.value = n;
          if (range) range.value = Math.min(n, parseInt(range.max, 10) || 1500);
          var tr = trancheFor(n);
          if (tranche) tranche.textContent = 'tranche ' + tr;
          var stored = n + ' (' + tr + ')';
          if (hidden) hidden.value = stored;
          state.couverts = stored;
          state.couverts_num = n;
          save();
          hideStepError();
          if (input) input.removeAttribute('aria-invalid');
        }
        if (input) input.addEventListener('input', function () { syncFromNumber(input.value); });
        if (range) range.addEventListener('input', function () { syncFromNumber(range.value); });
        // Init depuis state restore
        var restored = state.couverts_num;
        if (restored != null) syncFromNumber(restored);
        else syncFromNumber(input ? input.value : 100);
      });

      // Wire inputs
      quoteForm.querySelectorAll('[data-name]').forEach(function (input) {
        if (input.hasAttribute('data-cards')) return;
        if (input.type === 'checkbox') {
          input.addEventListener('change', function () {
            state[input.dataset.name] = input.checked;
            save();
          });
        } else if (input.tagName === 'INPUT' || input.tagName === 'SELECT' || input.tagName === 'TEXTAREA') {
          input.addEventListener('input', function () {
            state[input.dataset.name] = input.value;
            save();
            if (input.hasAttribute('data-vat')) validateVatField(input);
          });
          input.addEventListener('change', function () {
            state[input.dataset.name] = input.value;
            save();
          });
        }
      });

      function validateVatField(input) {
        var val = cleanVat(input.value);
        if (val !== input.value) {
          var p = input.selectionStart;
          input.value = val;
          try { input.setSelectionRange(p, p); } catch (_) {}
        }
        if (val.length === 0) {
          input.removeAttribute('data-vat-state');
          return true;
        }
        var res = validateVat(val);
        input.setAttribute('data-vat-state', res.ok ? 'valid' : 'invalid');
        return res.ok;
      }

      // Wizard navigation
      function goToStep(n) {
        if (n < 1 || n > TOTAL) return;
        if (n > current) {
          // valider l'etape courante avant d'avancer
          if (!validateStep(current)) return;
        }
        STEPS.forEach(function (s) { s.classList.remove('is-active'); });
        var target = quoteForm.querySelector('[data-step="' + n + '"]');
        if (target) target.classList.add('is-active');
        current = n;
        updateProgress();
        updateNav();
        if (n === TOTAL) renderRecap();
        // Scroll haut du form
        quoteForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      function updateProgress() {
        var pct = (current / TOTAL) * 100;
        if (progressFill) progressFill.style.width = pct + '%';
        progressSteps.forEach(function (btn, i) {
          var n = i + 1;
          btn.classList.remove('is-active', 'is-done');
          if (n < current) btn.classList.add('is-done');
          if (n === current) btn.classList.add('is-active');
        });
      }
      function updateNav() {
        if (btnPrev) btnPrev.hidden = current === 1;
        if (btnNext) btnNext.hidden = current === TOTAL;
        if (btnSubmit) btnSubmit.hidden = current !== TOTAL;
      }

      function validateStep(n) {
        var step = quoteForm.querySelector('[data-step="' + n + '"]');
        if (!step) return true;
        var ok = true;
        var firstInvalid = null;
        var missingCount = 0;
        // Groupes de cards obligatoires
        step.querySelectorAll('[data-cards][data-required]').forEach(function (group) {
          var active = group.querySelectorAll('.lemust-wizard-card.is-active').length;
          if (active === 0) {
            ok = false; missingCount++;
            group.classList.add('is-invalid');
            if (!firstInvalid) firstInvalid = group;
          } else {
            group.classList.remove('is-invalid');
          }
        });
        // Inputs obligatoires
        step.querySelectorAll('input[data-required], select[data-required], textarea[data-required]').forEach(function (input) {
          var v = input.value.trim();
          var invalid = false;
          var reason = '';
          if (input.type === 'checkbox') {
            if (!input.checked) { invalid = true; reason = 'consent'; }
          } else {
            if (!v) invalid = true;
            if (input.type === 'email' && v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { invalid = true; reason = 'email'; }
            if (input.hasAttribute('data-vat') && v && !validateVat(v).ok) { invalid = true; reason = 'vat'; }
          }
          if (invalid) {
            ok = false; missingCount++;
            input.setAttribute('aria-invalid', 'true');
            if (!firstInvalid) firstInvalid = { el: input, reason: reason };
          } else {
            input.removeAttribute('aria-invalid');
          }
        });
        if (!ok) {
          var msg = 'Merci de compléter tous les champs obligatoires';
          if (firstInvalid && firstInvalid.reason === 'email') msg = 'Adresse email invalide';
          else if (firstInvalid && firstInvalid.reason === 'vat') msg = 'Numéro de TVA invalide';
          else if (firstInvalid && firstInvalid.reason === 'consent') msg = 'Merci d\'accepter d\'être recontacté pour continuer';
          showStepError(msg);
          var target = firstInvalid && firstInvalid.el ? firstInvalid.el : firstInvalid;
          if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (target && target.focus) target.focus();
        } else {
          hideStepError();
        }
        return ok;
      }

      function showStepError(msg) {
        var err = root.querySelector('[data-step-error]');
        if (!err) {
          err = document.createElement('div');
          err.className = 'lemust-wizard-error';
          err.setAttribute('data-step-error', '');
          err.setAttribute('role', 'alert');
          var nav = root.querySelector('.lemust-wizard-nav');
          if (nav) nav.parentNode.insertBefore(err, nav);
        }
        err.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg><span>' + escapeHtml(msg) + '</span>';
        err.hidden = false;
      }
      function hideStepError() {
        var err = root.querySelector('[data-step-error]');
        if (err) err.hidden = true;
      }
      function escapeHtml(s) {
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }

      // Boutons prev/next
      if (btnNext) btnNext.addEventListener('click', function () { goToStep(current + 1); });
      if (btnPrev) btnPrev.addEventListener('click', function () { goToStep(current - 1); });
      progressSteps.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = parseInt(btn.dataset.gotoStep, 10);
          // Autorise le retour, mais valide si on avance
          if (n < current || validateStep(current)) goToStep(n);
        });
      });

      // Recap
      function renderRecap() {
        if (!recapBody) return;
        var mapping = [
          ['etablissement_type',  "Type d'établissement"],
          ['etablissement_nom',   "Établissement"],
          ['etablissement_ville', "Ville"],
          ['etablissement_pays',  "Pays"],
          ['couverts',            "Couverts/jour"],
          ['frequence',           "Fréquence"],
          ['volume',              "Volume mensuel"],
          ['gammes',              "Gammes"],
          ['types',               "Types"],
          ['certifs',             "Certifications"],
          ['date',                "Échéance"],
          ['adresse',             "Adresse"],
          ['cp',                  "Code postal"]
        ];
        var html = '';
        mapping.forEach(function (pair) {
          var v = state[pair[0]];
          if (v) html += '<div class="lemust-wizard-recap__row"><span>' + pair[1] + '</span><span>' + escapeHtml(v) + '</span></div>';
        });
        recapBody.innerHTML = html || '<div class="lemust-wizard-recap__row"><span>Aucune donnée pour l’instant</span></div>';
      }

      // Submit final
      quoteForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!validateStep(current)) return;
        // Construit un body texte complet
        var lines = ['Nouvelle demande de devis', ''];
        var mapping = [
          ['etablissement_type',  "Type d'établissement"],
          ['etablissement_nom',   "Établissement"],
          ['etablissement_ville', "Ville"],
          ['etablissement_pays',  "Pays"],
          ['couverts',            "Couverts/jour"],
          ['frequence',           "Fréquence"],
          ['volume',              "Volume mensuel"],
          ['gammes',              "Gammes"],
          ['types',               "Types"],
          ['certifs',             "Certifications"],
          ['date',                "Échéance"],
          ['adresse',             "Adresse"],
          ['cp',                  "Code postal"],
          ['message_libre',       "Message libre"],
          ['prenom',              "Prénom"],
          ['nom',                 "Nom"],
          ['fonction',            "Fonction"],
          ['email',               "Email"],
          ['tel',                 "Téléphone"],
          ['tva',                 "TVA"]
        ];
        mapping.forEach(function (pair) {
          if (state[pair[0]]) lines.push(pair[1] + ' : ' + state[pair[0]]);
        });
        if (hiddenBody) hiddenBody.value = lines.join('\n');

        btnSubmit.disabled = true;
        var orig = btnSubmit.innerHTML;
        btnSubmit.textContent = 'Envoi…';
        if (quoteStatus) { quoteStatus.hidden = true; quoteStatus.className = 'lemust-contact-form__status'; }

        var fd = new FormData(quoteForm);
        fetch(quoteForm.getAttribute('action'), { method: 'POST', body: fd, headers: { 'Accept': 'text/html' } })
          .then(function (r) {
            if (r.ok || r.status === 302 || (r.status >= 200 && r.status < 400)) {
              clearStorage();
              state = {};
              showSuccessScreen(quoteWrap, 'Demande envoyée', 'Merci, votre demande de devis nous est bien parvenue. Notre équipe commerciale l\'étudie et revient vers vous avec une proposition personnalisée.', '48h ouvrées');
            } else throw new Error('HTTP ' + r.status);
          })
          .catch(function (err) {
            console.error('[Contact Hub] Submit failed', err);
            if (quoteStatus) {
              quoteStatus.hidden = false;
              quoteStatus.classList.add('is-error');
              quoteStatus.textContent = 'Une erreur est survenue. Merci de réessayer.';
            }
            btnSubmit.disabled = false;
            btnSubmit.innerHTML = orig;
          });
      });

      function escapeHtml(s) {
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }

      // Init
      restore();
      updateProgress();
      updateNav();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lemust-mega-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var media = window.matchMedia('(min-width: 990px) and (hover: hover)');
    if (!media.matches) return;

    document.querySelectorAll('[data-lemust-mega]').forEach(init);

    function samePath(a, b) {
      function norm(u) {
        try { u = new URL(u, window.location.origin).pathname; } catch (e) { return String(u || ''); }
        return u.replace(/\/+$/, '').toLowerCase();
      }
      return norm(a) === norm(b);
    }

    function init(root) {
      if (root._lemustMegaInit) return;
      root._lemustMegaInit = true;

      var openDelay  = parseInt(root.dataset.openDelay, 10) || 120;
      var closeDelay = parseInt(root.dataset.closeDelay, 10) || 220;
      var useBackdrop = root.dataset.backdrop === 'true';
      var backdrop = root.querySelector('[data-mega-backdrop]');
      var headerEl = document.querySelector('.shopify-section.section-header, [id$="__header"].shopify-section');
      var links = Array.from(document.querySelectorAll('a.header__menu-link'));
      var pairs = [];
      var current = null;
      var openTimer = null, closeTimer = null;

      root.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
        var url = panel.dataset.linkUrl;
        var link = links.find(function (a) { return samePath(a.getAttribute('href'), url); });
        if (!link) return;
        link.setAttribute('aria-haspopup', 'true');
        link.setAttribute('aria-expanded', 'false');
        link.setAttribute('aria-controls', panel.id);
        pairs.push({ link: link, panel: panel });
      });
      if (!pairs.length) return;

      function place(panel) {
        if (!headerEl) return;
        var r = headerEl.getBoundingClientRect();
        panel.style.top = Math.max(0, Math.round(r.bottom)) + 'px';
      }

      function open(pair) {
        clearTimeout(closeTimer);
        if (current && current !== pair) closeNow(current);
        current = pair;
        place(pair.panel);
        pair.panel.hidden = false;
        // double rAF : laisse le navigateur peindre l'etat hidden=false avant la transition
        requestAnimationFrame(function () { requestAnimationFrame(function () { pair.panel.classList.add('is-open'); }); });
        pair.link.classList.add('is-mega-open');
        pair.link.setAttribute('aria-expanded', 'true');
        if (useBackdrop && backdrop) { backdrop.hidden = false; requestAnimationFrame(function () { backdrop.classList.add('is-visible'); }); }
      }

      function closeNow(pair) {
        pair.panel.classList.remove('is-open');
        pair.link.classList.remove('is-mega-open');
        pair.link.setAttribute('aria-expanded', 'false');
        setTimeout(function () { if (!pair.panel.classList.contains('is-open')) pair.panel.hidden = true; }, 200);
        if (current === pair) current = null;
        if (!current && backdrop) {
          backdrop.classList.remove('is-visible');
          setTimeout(function () { if (!backdrop.classList.contains('is-visible')) backdrop.hidden = true; }, 240);
        }
      }

      function scheduleOpen(pair) {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { open(pair); }, openDelay);
      }
      function scheduleClose() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { if (current) closeNow(current); }, closeDelay);
      }

      pairs.forEach(function (pair) {
        pair.link.addEventListener('mouseenter', function () { scheduleOpen(pair); });
        pair.link.addEventListener('mouseleave', scheduleClose);
        pair.panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); clearTimeout(openTimer); });
        pair.panel.addEventListener('mouseleave', scheduleClose);

        // Clavier
        pair.link.addEventListener('focus', function () { open(pair); });
        pair.link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); open(pair); var f = pair.panel.querySelector('a, button'); if (f) f.focus(); }
        });
        pair.panel.addEventListener('focusout', function (e) {
          if (!pair.panel.contains(e.relatedTarget) && e.relatedTarget !== pair.link) closeNow(pair);
        });
      });

      // Un autre lien du menu (sans panneau) survole -> fermer
      links.forEach(function (a) {
        if (pairs.some(function (p) { return p.link === a; })) return;
        a.addEventListener('mouseenter', scheduleClose);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && current) { var l = current.link; closeNow(current); l.focus(); }
      });
      window.addEventListener('scroll', function () { if (current) place(current.panel); }, { passive: true });
      window.addEventListener('resize', function () { if (current) place(current.panel); });
      document.addEventListener('click', function (e) {
        if (current && !current.panel.contains(e.target) && !current.link.contains(e.target)) closeNow(current);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orderpage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Sequence des paliers (nombre de pots) - units dynamiques par produit
    function stepToPots(step, unitsSmall, unitsLarge) {
      if (step <= 0) return 0;
      if (step === 1) return unitsSmall;
      return (step - 1) * unitsLarge;
    }
    function stepToVariantMix(step) {
      if (step <= 0) return { v16qty: 0, v48qty: 0 };
      if (step === 1) return { v16qty: 1, v48qty: 0 };
      return { v16qty: 0, v48qty: step - 1 };
    }
    function stepToDisplay(step, unitsSmall, unitsLarge) {
      if (step <= 0) return '0';
      if (step === 1) return '1×' + unitsSmall;
      return (step - 1) + '×' + unitsLarge;
    }
    function stepToFormatText(step, unitsSmall, unitsLarge) {
      if (step <= 0) return '';
      if (step === 1) return '1 carton de ' + unitsSmall;
      var n = step - 1;
      return n + ' carton' + (n > 1 ? 's' : '') + ' de ' + unitsLarge;
    }
    function readUnits(row) {
      return {
        small: parseInt(row.dataset.unitsSmall, 10) || 16,
        large: parseInt(row.dataset.unitsLarge, 10) || 48
      };
    }

    document.querySelectorAll('[data-section-type="lemust-order-form"]').forEach(initSection);

    function initSection(root) {
      // Garde anti double-init (editeur Shopify, hot-reload, section rendering API)
      if (root._lemustInited) return;
      root._lemustInited = true;

      var rows = Array.from(root.querySelectorAll('[data-row]'));
      if (!rows.length) return;

      var sidebar = {
        count:      root.querySelector('[data-sb-count]'),
        bigPots:    root.querySelector('[data-sb-big-pots]'),
        bigCartons: root.querySelector('[data-sb-big-cartons]'),
        list:       root.querySelector('[data-sb-list]'),
        totals:     root.querySelector('[data-sb-totals]'),
        total:      root.querySelector('[data-sb-total]'),
        addBtn:     root.querySelector('[data-sb-add]'),
        clearBtn:   root.querySelector('[data-sb-clear]'),
        toast:      root.querySelector('[data-sb-toast]')
      };
      var subtotal = {
        wrap:    root.querySelector('[data-subtotal]'),
        cartons: root.querySelector('[data-sub-cartons]'),
        pots:    root.querySelector('[data-sub-pots]'),
        total:   root.querySelector('[data-sub-total]')
      };
      var modal = {
        el:   root.querySelector('[data-modal]'),
        body: root.querySelector('[data-modal-body]'),
        data: root.querySelector('[data-modal-data]')
      };
      var mobileBar = {
        el:        root.querySelector('[data-mobile-bar]'),
        count:     root.querySelector('[data-mob-count]'),
        total:     root.querySelector('[data-mob-total]'),
        scrollBtn: root.querySelector('[data-mob-scroll]')
      };

      var fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

      // Cle de persistance : uniquement basee sur section-id (stable a travers les refresh)
      var STORAGE_KEY = 'lemust-order-v1-' + (root.dataset.sectionId || 'default');

      // ---- Parser du grammage (contenance) en grammes ----
      function parseWeightG(str) {
        if (!str) return { grams: 0, unit: '', isVolume: false };
        var s = String(str).toLowerCase().replace(',', '.').replace(/\s+/g, '');
        var m = s.match(/^([\d.]+)(kg|g|mg|ml|cl|l)?$/);
        if (!m) return { grams: 0, unit: '', isVolume: false };
        var n = parseFloat(m[1]);
        var unit = m[2] || 'g';
        if (unit === 'kg') return { grams: n * 1000, unit: 'kg', isVolume: false };
        if (unit === 'g')  return { grams: n, unit: 'g', isVolume: false };
        if (unit === 'mg') return { grams: n / 1000, unit: 'mg', isVolume: false };
        if (unit === 'ml') return { grams: n, unit: 'ml', isVolume: true };
        if (unit === 'cl') return { grams: n * 10, unit: 'cl', isVolume: true };
        if (unit === 'l')  return { grams: n * 1000, unit: 'L', isVolume: true };
        return { grams: n, unit: '', isVolume: false };
      }

      // Renvoie un HTML "≈ X € / kg" (ou "/ L" si volume) ou '' si pas de contenance
      function pricePerUnitHtml(pricePotCents, contenance) {
        var w = parseWeightG(contenance);
        if (w.grams <= 0) return '';
        var pricePerG = (pricePotCents / 100) / w.grams; // en €/g
        var perKg = pricePerG * 1000;
        var label = w.isVolume ? ' / L' : ' / kg';
        return '<span class="lemust-price-perkg">≈ ' + fmt.format(perKg) + label + '</span>';
      }

      // === Refs DOM (avant les init pour eviter les problemes de hoisting var) ===
      var filterBar      = root.querySelector('[data-filters]');
      var emptyState     = root.querySelector('[data-filters-empty]');
      var filterState    = { gamme: new Set(), type: new Set() };
      var businessToggle = root.querySelector('[data-business-toggle]');
      var businessField  = root.querySelector('[data-business-field]');
      var vatInput       = root.querySelector('[data-vat-input]');
      var packingCurrent = null;
      var quoteModal = {
        el:      root.querySelector('[data-quote]'),
        form:    root.querySelector('[data-quote-form]'),
        packing: root.querySelector('[data-quote-packing]'),
        body:    root.querySelector('[data-quote-body]'),
        vat:     root.querySelector('[data-quote-vat]'),
        total:   root.querySelector('[data-quote-total]'),
        pots:    root.querySelector('[data-quote-pots]'),
        cartons: root.querySelector('[data-quote-cartons]'),
        status:  root.querySelector('[data-quote-status]'),
        submit:  root.querySelector('[data-quote-submit]'),
        openBtns: root.querySelectorAll('[data-quote-open]')
      };
      var packingModal = {
        el:         root.querySelector('[data-packing]'),
        body:       root.querySelector('[data-packing-body]'),
        pots:       root.querySelector('[data-packing-pots]'),
        cartons:    root.querySelector('[data-packing-cartons]'),
        total:      root.querySelector('[data-packing-total]'),
        palette:    root.querySelector('[data-packing-palette]'),
        paletteT:   root.querySelector('[data-packing-palette-title]'),
        paletteD:   root.querySelector('[data-packing-palette-desc]'),
        business:   root.querySelector('[data-packing-business]'),
        vat:        root.querySelector('[data-packing-vat]'),
        confirmBtn: root.querySelector('[data-packing-confirm]')
      };

      var typeKeywordFor = function (raw) {
        if (!raw) return '';
        var s = raw.toLowerCase();
        if (s.indexOf('confiture') !== -1)   return 'Confitures';
        if (s.indexOf('miel') !== -1)        return 'Miel';
        if (s.indexOf('condiment') !== -1)   return 'Condiments';
        if (s.indexOf('douceur') !== -1)     return 'Douceurs';
        if (s.indexOf('plateau') !== -1)     return 'Plateaux';
        var first = raw.trim().split(/\s+/)[0] || '';
        return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
      };

      // ---- Persistance localStorage : sauvegarde/restore de la selection ----
      // Cle unique par ligne : gammeKey + productId (evite les doublons si un produit
      // apparait dans plusieurs collections/gammes).
      function rowKey(row) {
        return (row.dataset.gammeKey || 'x') + '_' + (row.dataset.productId || '');
      }
      function saveSelection() {
        try {
          var data = { rows: {}, business: false, vat: '' };
          rows.forEach(function (row) {
            var stepper = row.querySelector('[data-stepper]');
            var step = parseInt(stepper.dataset.step, 10) || 0;
            if (step > 0) data.rows[rowKey(row)] = step;
          });
          if (businessToggle && businessToggle.checked) {
            data.business = true;
            data.vat = vatInput ? vatInput.value : '';
          }
          if (Object.keys(data.rows).length === 0 && !data.business) {
            localStorage.removeItem(STORAGE_KEY);
          } else {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
          }
        } catch (e) { /* localStorage indispo, ignore */ }
      }
      function restoreSelection() {
        try {
          var raw = localStorage.getItem(STORAGE_KEY);
          if (!raw) return;
          var data = JSON.parse(raw);
          if (data.rows) {
            rows.forEach(function (row) {
              var s = parseInt(data.rows[rowKey(row)], 10);
              if (s && s > 0) {
                var stepper = row.querySelector('[data-stepper]');
                if (stepper) stepper.dataset.step = String(s);
              }
            });
          }
          if (data.business && businessToggle) {
            businessToggle.checked = true;
            if (vatInput) vatInput.value = data.vat || '';
            businessToggle.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } catch (e) { /* ignore */ }
      }
      function clearSelectionStorage() {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      }

      // ---- Stock badge : classe tonale a partir du texte ----
      function stockTone(str) {
        var s = (str || '').toLowerCase();
        if (!s) return null;
        if (s.indexOf('rupture') !== -1 || s.indexOf('épuisé') !== -1 ||
            s.indexOf('epuise') !== -1 || s.indexOf('out') !== -1) return 'out';
        if (s.indexOf('bientôt') !== -1 || s.indexOf('bientot') !== -1 ||
            s.indexOf('quelques') !== -1 || s.indexOf('faible') !== -1 ||
            s.indexOf('low') !== -1 || s.indexOf('limité') !== -1 ||
            s.indexOf('demande') !== -1) return 'low';
        return 'in';
      }
      function applyStockBadgeTones() {
        rows.forEach(function (row) {
          var badge = row.querySelector('[data-stock-badge]');
          if (!badge) return;
          var tone = stockTone(row.dataset.stockStatus);
          if (tone) badge.setAttribute('data-stock-tone', tone);
          // Rupture : desactive stepper +
          if (tone === 'out') {
            row.querySelectorAll('[data-step-dir="1"]').forEach(function (b) {
              b.disabled = true;
              b.setAttribute('title', 'Produit en rupture');
            });
            row.classList.add('lemust-row--out');
          }
        });
      }

      initCatalogueCards();
      rows.forEach(initRow);
      initModalClose();
      initFilters();
      initViewToggle();
      initBusinessToggle();
      initQuoteModal();
      initReorder();
      applyStockBadgeTones();

      if (sidebar.addBtn) sidebar.addBtn.addEventListener('click', openPackingList);
      if (sidebar.clearBtn) sidebar.clearBtn.addEventListener('click', clearAllSelection);
      initPackingModal();
      if (mobileBar.scrollBtn) {
        mobileBar.scrollBtn.addEventListener('click', function () {
          var target = root.querySelector('[data-sidebar]') || sidebar.addBtn;
          if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      // Restore la selection depuis localStorage avant le premier recompute
      restoreSelection();
      recompute();

      // ============================================================
      function initRow(row) {
        var stepper = row.querySelector('[data-stepper]');
        var input   = stepper && stepper.querySelector('[data-stepper-display]');
        if (!stepper || !input) return;

        stepper.addEventListener('click', function (e) { e.stopPropagation(); });

        stepper.querySelectorAll('[data-step-dir]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var dir = parseInt(btn.dataset.stepDir, 10);
            var cur = parseInt(stepper.dataset.step, 10) || 0;
            var next = cur + dir;
            if (next < 0) next = 0;
            var prevStep = cur;
            stepper.dataset.step = next;
            if (prevStep === 1 && next === 2) {
              row.setAttribute('data-tier-flash', '');
              setTimeout(function () { row.removeAttribute('data-tier-flash'); }, 800);
            }
            recompute();
          });
        });

        // Bouton × ligne : reset step à 0
        var clearBtn = row.querySelector('[data-row-clear]');
        if (clearBtn) {
          clearBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            stepper.dataset.step = '0';
            recompute();
          });
        }

        // Bouton "i" info -> ouvre modale
        var infoBtn = row.querySelector('[data-row-info]');
        if (infoBtn) {
          infoBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            openModalFor(row);
          });
        }

        // Clic ligne (hors stepper/actions/info) → ouvre modale
        row.addEventListener('click', function (e) {
          if (e.target.closest('[data-stepper]')) return;
          if (e.target.closest('[data-row-clear]')) return;
          if (e.target.closest('[data-row-info]')) return;
          openModalFor(row);
        });
        row.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.target.closest('[data-stepper]')) return;
            if (e.target.closest('[data-row-clear]')) return;
            if (e.target.closest('[data-row-info]')) return;
            e.preventDefault();
            openModalFor(row);
          }
        });
      }

      // ============================================================
      // VIEW TOGGLE (Tableau / Catalogue)
      // ============================================================
      function initViewToggle() {
        var toggle = root.querySelector('[data-view-toggle]');
        var main   = root.querySelector('.lemust-order__main');
        if (!toggle || !main) return;
        toggle.querySelectorAll('[data-view-btn]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var mode = btn.dataset.viewBtn;
            main.dataset.view = mode;
            toggle.querySelectorAll('[data-view-btn]').forEach(function (b) {
              b.classList.toggle('is-active', b === btn);
            });
          });
        });
      }

      // ============================================================
      // BUSINESS TOGGLE (case entreprise + champ TVA)
      // ============================================================
      function initBusinessToggle() {
        if (!businessToggle || !businessField) return;
        function syncBusinessField() {
          if (businessToggle.checked) {
            businessField.removeAttribute('hidden');
            businessField.hidden = false;
            if (vatInput) setTimeout(function () { vatInput.focus(); }, 100);
          } else {
            businessField.setAttribute('hidden', '');
            businessField.hidden = true;
          }
        }
        businessToggle.addEventListener('change', syncBusinessField);
        businessToggle.addEventListener('click', function () {
          // Sync juste apres pour couvrir les cas ou change ne fire pas
          setTimeout(syncBusinessField, 0);
        });
        // Etat initial
        syncBusinessField();
        // Force uppercase
        if (vatInput) {
          vatInput.addEventListener('input', function () {
            var s = vatInput.selectionStart;
            vatInput.value = vatInput.value.toUpperCase().replace(/\s+/g, '');
            try { vatInput.setSelectionRange(s, s); } catch (_) {}
          });
        }
      }

      function getBusinessAttributes() {
        if (!businessToggle || !businessToggle.checked) return null;
        var vat = vatInput ? vatInput.value.trim() : '';
        if (!vat) return { valid: false, error: 'Merci de renseigner votre numéro de TVA.' };
        return {
          valid: true,
          attributes: {
            'Commande entreprise': 'oui',
            'Numéro de TVA': vat
          }
        };
      }

      function clearAllSelection() {
        rows.forEach(function (row) {
          var stepper = row.querySelector('[data-stepper]');
          if (stepper) stepper.dataset.step = '0';
        });
        clearSelectionStorage();
        recompute();
      }

      // ============================================================
      // FILTRES : construits dynamiquement + application des filtres
      // ============================================================
      function initFilters() {
        if (!filterBar) return;

        // Collecte des gammes (par bloc)
        var gammesMap = new Map(); // label -> count rows
        var typesMap  = new Map(); // keyword -> count rows
        rows.forEach(function (row) {
          var gammeKey = row.dataset.gammeKey || '';
          var gammeBlock = root.querySelector('[data-gamme-block][data-gamme-key="' + gammeKey + '"]');
          var gammeLabel = gammeBlock ? (gammeBlock.dataset.gammeLabel || '') : '';
          if (gammeLabel) {
            gammesMap.set(gammeLabel, (gammesMap.get(gammeLabel) || 0) + 1);
          }
          var kw = typeKeywordFor(row.dataset.typeProduit);
          if (kw) typesMap.set(kw, (typesMap.get(kw) || 0) + 1);
        });

        if (gammesMap.size === 0 && typesMap.size === 0) return;

        buildChips('gamme', gammesMap);
        buildChips('type',  typesMap);
        filterBar.hidden = false;

        var resetBtn = filterBar.querySelector('[data-filter-reset]');
        if (resetBtn) resetBtn.addEventListener('click', resetFilters);

        applyFilters();
      }

      function buildChips(group, map) {
        var container = filterBar.querySelector('[data-filter-chips="' + group + '"]');
        if (!container || map.size === 0) {
          // Cache tout le groupe si vide
          var grp = filterBar.querySelector('[data-filter-group="' + group + '"]');
          if (grp) grp.hidden = true;
          return;
        }
        // Ordre : tri alphabetique, mais Deluxe/Premium/Plateaux en priorite pour gammes
        var priority = ['Gamme Deluxe', 'Gamme Premium', 'Plateaux', 'Confitures', 'Miel', 'Condiments', 'Douceurs'];
        var keys = Array.from(map.keys()).sort(function (a, b) {
          var ia = priority.indexOf(a), ib = priority.indexOf(b);
          if (ia !== -1 && ib === -1) return -1;
          if (ib !== -1 && ia === -1) return 1;
          if (ia !== -1 && ib !== -1) return ia - ib;
          return a.localeCompare(b, 'fr');
        });
        keys.forEach(function (key) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'lemust-filter-chip';
          chip.dataset.filterValue = key;
          chip.innerHTML = escapeHtml(key) + ' <span class="lemust-filter-chip__count">' + map.get(key) + '</span>';
          chip.addEventListener('click', function () {
            toggleFilter(group, key, chip);
          });
          container.appendChild(chip);
        });
      }

      function toggleFilter(group, value, chip) {
        if (filterState[group].has(value)) {
          filterState[group].delete(value);
          chip.classList.remove('is-active');
        } else {
          filterState[group].add(value);
          chip.classList.add('is-active');
        }
        applyFilters();
      }

      function resetFilters() {
        filterState.gamme.clear();
        filterState.type.clear();
        filterBar.querySelectorAll('.lemust-filter-chip.is-active').forEach(function (c) {
          c.classList.remove('is-active');
        });
        applyFilters();
      }

      function applyFilters() {
        var gActive = filterState.gamme.size > 0;
        var tActive = filterState.type.size > 0;
        var anyActive = gActive || tActive;
        var visibleCount = 0;

        // Cache/affiche les rows
        rows.forEach(function (row) {
          var gammeKey = row.dataset.gammeKey || '';
          var gammeBlock = root.querySelector('[data-gamme-block][data-gamme-key="' + gammeKey + '"]');
          var gammeLabel = gammeBlock ? (gammeBlock.dataset.gammeLabel || '') : '';
          var kw = typeKeywordFor(row.dataset.typeProduit);

          var passGamme = !gActive || filterState.gamme.has(gammeLabel);
          var passType  = !tActive || filterState.type.has(kw);
          var visible = passGamme && passType;

          if (visible) {
            row.removeAttribute('data-filter-hidden');
            visibleCount++;
          } else {
            row.setAttribute('data-filter-hidden', '');
          }
        });

        // Cache/affiche les separateurs sous-groupes selon leur type_produit associe (row suivante)
        root.querySelectorAll('.lemust-subgroup').forEach(function (sub) {
          // Trouve la row suivante
          var next = sub.nextElementSibling;
          while (next && !next.matches('[data-row]')) next = next.nextElementSibling;
          if (next && !next.hasAttribute('data-filter-hidden')) {
            sub.removeAttribute('data-filter-hidden');
          } else {
            sub.setAttribute('data-filter-hidden', '');
          }
        });

        // Cache accordeons entierement filtres
        root.querySelectorAll('[data-gamme-block]').forEach(function (gamme) {
          var visibleRows = gamme.querySelectorAll('[data-row]:not([data-filter-hidden])');
          if (visibleRows.length === 0 && anyActive) {
            gamme.setAttribute('data-filter-hidden', '');
          } else {
            gamme.removeAttribute('data-filter-hidden');
          }
        });

        // Cache les cartes catalogue mobile associees
        rows.forEach(function (row) {
          var pid = row.dataset.productId;
          var cards = root.querySelectorAll('.lemust-cat-card[data-product-id="' + pid + '"]');
          cards.forEach(function (card) {
            if (row.hasAttribute('data-filter-hidden')) card.setAttribute('data-filter-hidden', '');
            else card.removeAttribute('data-filter-hidden');
          });
        });

        // Compteur + empty state
        var count    = filterBar && filterBar.querySelector('[data-filter-count]');
        var countVal = filterBar && filterBar.querySelector('[data-filter-count-value]');
        var countPlu = filterBar && filterBar.querySelector('[data-filter-count-plural]');
        var reset    = filterBar && filterBar.querySelector('[data-filter-reset]');
        if (anyActive) {
          if (count)    count.hidden = false;
          if (countVal) countVal.textContent = visibleCount;
          if (countPlu) countPlu.textContent = visibleCount > 1 ? 's' : '';
          if (reset)    reset.hidden = false;
        } else {
          if (count) count.hidden = true;
          if (reset) reset.hidden = true;
        }
        if (emptyState) emptyState.hidden = !(anyActive && visibleCount === 0);
      }

      // ============================================================
      function initCatalogueCards() {
        var gammes = root.querySelectorAll('[data-gamme-block]');
        gammes.forEach(function (gamme) {
          var grid = gamme.querySelector('[data-gamme-cards]');
          if (!grid) return;
          var gammeRows = gamme.querySelectorAll('[data-row]');
          gammeRows.forEach(function (row) {
            grid.appendChild(buildCatalogueCard(row));
          });
        });
      }

      function buildCatalogueCard(row) {
        var card = document.createElement('div');
        card.className = 'lemust-cat-card';
        card.dataset.productId = row.dataset.productId;

        var img = row.querySelector('.lemust-row__img');
        var name = row.dataset.productTitle;
        var contenance = row.dataset.contenance || '';
        var trous = row.dataset.nombreTrous || '';
        var isPlateau = row.dataset.plateau === 'true';
        var p16 = parseInt(row.dataset.p16Cents, 10) || 0;
        var p48 = parseInt(row.dataset.p48Cents, 10) || 0;

        var hero = document.createElement('div');
        hero.className = 'lemust-cat-card__hero';
        if (img) {
          var i = document.createElement('img');
          i.src = img.src; i.alt = name; i.loading = 'lazy';
          hero.appendChild(i);
        }
        card.appendChild(hero);

        var body = document.createElement('div');
        body.className = 'lemust-cat-card__body';

        var nm = document.createElement('span');
        nm.className = 'lemust-cat-card__name';
        nm.textContent = name;
        body.appendChild(nm);

        var meta = isPlateau ? trous : contenance;
        if (meta) {
          var co = document.createElement('span');
          co.className = 'lemust-cat-card__contenance';
          co.textContent = isPlateau && meta ? meta + ' trous' : meta;
          body.appendChild(co);
        }

        var cardUnits = readUnits(row);
        var pr = document.createElement('div');
        pr.className = 'lemust-cat-card__price';
        pr.dataset.catPrice = '1';
        pr.innerHTML = '<strong>' + fmt.format(p16 / 100) + '</strong> /' + cardUnits.small + ' · <strong>' + fmt.format(p48 / 100) + '</strong> /' + cardUnits.large;
        body.appendChild(pr);

        var rowStepper = row.querySelector('[data-stepper]');
        var qtyWrap = document.createElement('div');
        qtyWrap.className = 'lemust-cat-card__qty';
        qtyWrap.innerHTML =
          '<div class="lemust-stepper">' +
            '<button type="button" class="lemust-stepper__btn" data-cat-step="-1" aria-label="Diminuer">' +
              '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M5 11h14v2H5z"/></svg>' +
            '</button>' +
            '<span class="lemust-stepper__display" data-cat-display>0</span>' +
            '<button type="button" class="lemust-stepper__btn" data-cat-step="1" aria-label="Augmenter">' +
              '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"/></svg>' +
            '</button>' +
          '</div>' +
          '<span class="lemust-cat-card__format" data-cat-format></span>' +
          '<span class="lemust-cat-card__total" data-cat-total>—</span>';
        body.appendChild(qtyWrap);
        card.appendChild(body);

        qtyWrap.querySelectorAll('[data-cat-step]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            var dir = parseInt(btn.dataset.catStep, 10);
            var cur = parseInt(rowStepper.dataset.step, 10) || 0;
            var next = cur + dir;
            if (next < 0) next = 0;
            rowStepper.dataset.step = next;
            recompute();
          });
        });

        card.addEventListener('click', function (e) {
          if (e.target.closest('.lemust-stepper')) return;
          openModalFor(row);
        });

        row._catPrice   = pr;
        row._catDisplay = qtyWrap.querySelector('[data-cat-display]');
        row._catFormat  = qtyWrap.querySelector('[data-cat-format]');
        row._catTotal   = qtyWrap.querySelector('[data-cat-total]');
        return card;
      }

      // ============================================================
      function openModalFor(row) {
        if (!modal.el || !modal.body || !modal.data) return;
        var pid = row.dataset.productId;
        var tpl = modal.data.querySelector('template[data-product-id="' + pid + '"]');
        if (!tpl) return;
        modal.body.innerHTML = '';
        modal.body.appendChild(tpl.content.cloneNode(true));

        // Wire du carrousel d'images
        var heroImg = modal.body.querySelector('[data-modal-hero]');
        var thumbs  = modal.body.querySelectorAll('[data-modal-thumb]');
        if (heroImg && thumbs.length) {
          thumbs.forEach(function (t) {
            t.addEventListener('click', function () {
              var url = t.dataset.full;
              if (!url) return;
              heroImg.style.opacity = '0.3';
              var tmp = new Image();
              tmp.onload = function () {
                heroImg.src = url;
                heroImg.style.opacity = '1';
              };
              tmp.src = url;
              thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
            });
          });
        }

        var qtyZone = modal.body.querySelector('[data-modal-qty-zone]');
        if (qtyZone) {
          var rowStepper = row.querySelector('[data-stepper]');
          var currentStep = parseInt(rowStepper.dataset.step, 10) || 0;
          var rowUnits = readUnits(row);
          qtyZone.innerHTML =
            '<div class="lemust-modal__qty-row">' +
              '<div class="lemust-modal__qty-info">' +
                '<span class="lemust-modal__qty-format" data-modal-format>—</span>' +
                '<span class="lemust-modal__qty-total" data-modal-total>0,00 €</span>' +
              '</div>' +
              '<div class="lemust-stepper">' +
                '<button type="button" class="lemust-stepper__btn" data-modal-step="-1" aria-label="Diminuer">' +
                  '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M5 11h14v2H5z"/></svg>' +
                '</button>' +
                '<span class="lemust-stepper__display" data-modal-display>' + stepToDisplay(currentStep, rowUnits.small, rowUnits.large) + '</span>' +
                '<button type="button" class="lemust-stepper__btn" data-modal-step="1" aria-label="Augmenter">' +
                  '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"/></svg>' +
                '</button>' +
              '</div>' +
              '<button type="button" class="button lemust-modal__qty-add" data-modal-close>Ajouter</button>' +
            '</div>';

          qtyZone.querySelectorAll('[data-modal-step]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var dir = parseInt(btn.dataset.modalStep, 10);
              var cur = parseInt(rowStepper.dataset.step, 10) || 0;
              var next = cur + dir;
              if (next < 0) next = 0;
              rowStepper.dataset.step = next;
              recompute();
            });
          });
          qtyZone.querySelectorAll('[data-modal-close]').forEach(function (el) {
            el.addEventListener('click', closeModal);
          });
          row._modalDisplay = qtyZone.querySelector('[data-modal-display]');
          row._modalFormat  = qtyZone.querySelector('[data-modal-format]');
          row._modalTotal   = qtyZone.querySelector('[data-modal-total]');
        }

        modal.el.querySelectorAll('[data-modal-close]').forEach(function (el) {
          el.addEventListener('click', closeModal);
        });

        modal.el._activeRow = row;
        modal.el.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      function initModalClose() {
        if (!modal.el) return;
        modal.el.querySelectorAll('[data-modal-close]').forEach(function (el) {
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.el.hidden) closeModal();
        });
      }
      function closeModal() {
        modal.el.hidden = true;
        document.body.style.overflow = '';
        rows.forEach(function (r) {
          r._modalDisplay = null;
          r._modalFormat = null;
          r._modalTotal = null;
        });
        modal.el._activeRow = null;
      }

      // ============================================================
      function recompute() {
        var totalPots = 0, totalCartons = 0, totalAmount = 0;
        var activeRows = [];
        var gammeStats = {};

        rows.forEach(function (row) {
          var stepper = row.querySelector('[data-stepper]');
          var step = parseInt(stepper.dataset.step, 10) || 0;
          var u = readUnits(row);
          var pots = stepToPots(step, u.small, u.large);
          var mix = stepToVariantMix(step);
          var p16 = parseInt(row.dataset.p16Cents, 10) || 0;
          var p48 = parseInt(row.dataset.p48Cents, 10) || 0;
          var cartonPrice = mix.v16qty * p16 + mix.v48qty * p48;
          var cartonsQty = mix.v16qty + mix.v48qty;
          var formatText = stepToFormatText(step, u.small, u.large);
          var displayText = stepToDisplay(step, u.small, u.large);
          var gammeKey = row.dataset.gammeKey || 'x';

          // MAJ affichage stepper + meta
          var stepperDisplay = stepper.querySelector('[data-stepper-display]');
          if (stepperDisplay) stepperDisplay.textContent = displayText;
          var meta = row.querySelector('[data-stepper-meta]');
          if (meta) {
            if (step === 0) meta.textContent = '';
            else if (step === 1) meta.innerHTML = '<strong>1 carton de ' + u.small + '</strong>';
            else {
              var n = step - 1;
              meta.innerHTML = '<strong>' + n + ' carton' + (n > 1 ? 's' : '') + ' de ' + u.large + '</strong>';
            }
          }

          // MAJ colonne prix : prix UNITAIRE par pot (+ prix/kg si contenance renseignee)
          var priceCell = row.querySelector('[data-cell-unit-price]');
          if (priceCell) {
            var unit16 = p16 / u.small;
            var unit48 = p48 / u.large;
            var activeUnitCents = (step === 1) ? unit16 : unit48;
            var perKg = pricePerUnitHtml(activeUnitCents, row.dataset.contenance);
            if (step === 0) {
              priceCell.innerHTML =
                '<span class="lemust-price-main"><strong>' + fmt.format(unit48 / 100) + '</strong> / pot</span>' +
                perKg +
                '<span class="lemust-price-hint">à partir de ' + u.small + ' pots</span>' +
                '<span class="lemust-price-sub">carton ' + u.small + ' : ' + fmt.format(unit16 / 100) + ' / pot</span>';
            } else if (step === 1) {
              priceCell.innerHTML =
                '<span class="lemust-price-main"><strong>' + fmt.format(unit16 / 100) + '</strong> / pot</span>' +
                perKg +
                '<span class="lemust-price-sub">1 × ' + fmt.format(p16 / 100) + ' (carton ' + u.small + ')</span>';
            } else {
              var nc = step - 1;
              priceCell.innerHTML =
                '<span class="lemust-price-main"><strong>' + fmt.format(unit48 / 100) + '</strong> / pot</span>' +
                perKg +
                '<span class="lemust-price-sub">' + nc + ' × ' + fmt.format(p48 / 100) + ' (carton ' + u.large + ')</span>';
            }
          }

          // MAJ colonne Carton (highlight du variant actif)
          var badge16 = row.querySelector('[data-carton-16]');
          var badge48 = row.querySelector('[data-carton-48]');
          if (badge16) badge16.classList.toggle('is-active', step === 1);
          if (badge48) badge48.classList.toggle('is-active', step >= 2);

          // MAJ sous-total ligne
          var totalCell = row.querySelector('[data-cell-total]');
          if (totalCell) totalCell.textContent = pots > 0 ? fmt.format(cartonPrice / 100) : '—';

          // Bouton × visible seulement si step > 0
          var clearBtn = row.querySelector('[data-row-clear]');
          if (clearBtn) clearBtn.hidden = step === 0;

          // MAJ carte catalogue
          if (row._catDisplay) row._catDisplay.textContent = displayText;
          if (row._catFormat)  row._catFormat.textContent = formatText || '';
          if (row._catTotal)   row._catTotal.textContent = pots > 0 ? fmt.format(cartonPrice / 100) : '—';
          if (row._catPrice) {
            if (step === 0) {
              row._catPrice.innerHTML = '<strong>' + fmt.format(p16 / 100) + '</strong> /' + u.small + ' · <strong>' + fmt.format(p48 / 100) + '</strong> /' + u.large;
            } else if (step === 1) {
              var unit16b = p16 / u.small;
              row._catPrice.innerHTML = '<strong>' + fmt.format(p16 / 100) + '</strong> — ' + fmt.format(unit16b / 100) + '/pot';
            } else {
              var unit48b = p48 / u.large;
              row._catPrice.innerHTML = '<strong>' + fmt.format(p48 / 100) + '</strong> × ' + (step - 1) + ' — ' + fmt.format(unit48b / 100) + '/pot';
            }
          }

          // MAJ modale
          if (row._modalDisplay) row._modalDisplay.textContent = displayText;
          if (row._modalFormat)  row._modalFormat.textContent = formatText || '';
          if (row._modalTotal)   row._modalTotal.textContent = pots > 0 ? fmt.format(cartonPrice / 100) : '0,00 €';

          if (step > 0) {
            totalPots    += pots;
            totalCartons += cartonsQty;
            totalAmount  += cartonPrice;
            activeRows.push({
              row: row, step: step, pots: pots, cartons: cartonsQty,
              subtotal: cartonPrice, format: formatText, mix: mix
            });
            if (!gammeStats[gammeKey]) gammeStats[gammeKey] = { count: 0 };
            gammeStats[gammeKey].count++;
          }
        });

        // MAJ badges accordeon
        root.querySelectorAll('[data-gamme-block]').forEach(function (gamme) {
          var key = gamme.dataset.gammeKey;
          var badge = gamme.querySelector('[data-gamme-selection]');
          var badgeCount = gamme.querySelector('[data-gamme-sel-count]');
          var badgePlural = gamme.querySelector('[data-gamme-sel-plural]');
          if (!badge) return;
          var stats = gammeStats[key];
          if (stats && stats.count > 0) {
            badge.hidden = false;
            if (badgeCount) badgeCount.textContent = stats.count;
            if (badgePlural) badgePlural.textContent = stats.count > 1 ? 's' : '';
          } else {
            badge.hidden = true;
          }
        });

        // Sous-total global
        if (subtotal.wrap) {
          if (activeRows.length > 0) {
            subtotal.wrap.hidden = false;
            if (subtotal.cartons) subtotal.cartons.textContent = totalCartons;
            if (subtotal.pots)    subtotal.pots.textContent = totalPots;
            if (subtotal.total)   subtotal.total.textContent = fmt.format(totalAmount / 100);
          } else {
            subtotal.wrap.hidden = true;
          }
        }

        updateSidebar(activeRows, totalPots, totalCartons, totalAmount);
        updateMobileBar(activeRows, totalPots, totalCartons, totalAmount);
        saveSelection();
      }

      function updateSidebar(activeRows, totalPots, totalCartons, totalAmount) {
        // Active/desactive le bouton "Demander un devis" en meme temps que le CTA
        if (quoteModal.openBtns && quoteModal.openBtns.length) {
          quoteModal.openBtns.forEach(function (btn) { btn.disabled = activeRows.length === 0; });
        }
        if (!sidebar.list) return;
        if (sidebar.count)      sidebar.count.textContent = activeRows.length + ' réf.';
        if (sidebar.bigPots)    sidebar.bigPots.textContent = totalPots;
        if (sidebar.bigCartons) sidebar.bigCartons.textContent = totalCartons + ' carton' + (totalCartons > 1 ? 's' : '');

        sidebar.list.innerHTML = '';
        if (!activeRows.length) {
          var li = document.createElement('li');
          li.className = 'lemust-sidebar__empty';
          li.textContent = 'Aucun produit sélectionné pour le moment.';
          sidebar.list.appendChild(li);
          if (sidebar.totals) sidebar.totals.hidden = true;
          if (sidebar.addBtn) sidebar.addBtn.disabled = true;
          if (sidebar.clearBtn) sidebar.clearBtn.hidden = true;
          return;
        }
        activeRows.forEach(function (item) {
          var li = document.createElement('li');
          li.className = 'lemust-sidebar__item';
          li.innerHTML =
            '<div class="lemust-sidebar__item-name">' +
              '<strong>' + escapeHtml(item.row.dataset.productTitle) + '</strong>' +
              '<span class="lemust-sidebar__item-detail">' + escapeHtml(item.format) + '</span>' +
            '</div>' +
            '<span class="lemust-sidebar__item-total">' + fmt.format(item.subtotal / 100) + '</span>';
          sidebar.list.appendChild(li);
        });
        if (sidebar.totals) sidebar.totals.hidden = false;
        if (sidebar.total)  sidebar.total.textContent = fmt.format(totalAmount / 100);
        if (sidebar.addBtn) sidebar.addBtn.disabled = false;
        if (sidebar.clearBtn) sidebar.clearBtn.hidden = false;
      }

      function updateMobileBar(activeRows, totalPots, totalCartons, totalAmount) {
        if (!mobileBar.el) return;
        var has = activeRows.length > 0;
        if (mobileBar.count) mobileBar.count.textContent = totalCartons + ' carton' + (totalCartons > 1 ? 's' : '') + ' · ' + totalPots + ' pot' + (totalPots > 1 ? 's' : '');
        if (mobileBar.total) mobileBar.total.textContent = fmt.format(totalAmount / 100);
        if (mobileBar.scrollBtn) mobileBar.scrollBtn.disabled = !has;
        if (has) {
          mobileBar.el.hidden = false;
          requestAnimationFrame(function () { mobileBar.el.classList.add('is-visible'); });
        } else {
          mobileBar.el.classList.remove('is-visible');
          setTimeout(function () {
            if (!mobileBar.el.classList.contains('is-visible')) mobileBar.el.hidden = true;
          }, 350);
        }
      }

      // ============================================================
      // REASSORT 1-CLIC : recharge la derniere commande du client
      // ============================================================
      function initReorder() {
        var wrap = root.querySelector('[data-reorder]');
        if (!wrap) return;
        var btn = wrap.querySelector('[data-reorder-btn]');
        if (!btn) return;
        var raw = wrap.dataset.reorderItems || '';
        if (!raw) return;

        var items = raw.split(',').map(function (pair) {
          var parts = pair.split(':');
          return { variantId: (parts[0] || '').trim(), qty: parseInt(parts[1], 10) || 0 };
        }).filter(function (it) { return it.variantId && it.qty > 0; });

        btn.addEventListener('click', function () {
          var matched = 0;
          rows.forEach(function (row) {
            var v16 = row.dataset.v16Id;
            var v48 = row.dataset.v48Id;
            var v16qty = 0, v48qty = 0;
            items.forEach(function (it) {
              if (it.variantId === v16) v16qty += it.qty;
              if (it.variantId === v48) v48qty += it.qty;
            });
            // Stepper exclusif : si mix, on privilegie le grand carton (moins cher/pot)
            var step = 0;
            if (v48qty > 0)      step = v48qty + 1;
            else if (v16qty > 0) step = 1;
            if (step > 0) {
              var stepper = row.querySelector('[data-stepper]');
              if (stepper) {
                stepper.dataset.step = step;
                matched++;
              }
            }
          });
          recompute();
          wrap.classList.add('is-applied');
          btn.textContent = '✓ ' + matched + ' produit' + (matched > 1 ? 's' : '') + ' chargé' + (matched > 1 ? 's' : '');
          btn.disabled = true;
        });
      }

      // ============================================================
      // DEMANDE DE DEVIS : modale de contact (POST vers /contact Shopify)
      // ============================================================
      function initQuoteModal() {
        if (!quoteModal.el) return;
        quoteModal.el.querySelectorAll('[data-quote-close]').forEach(function (el) {
          el.addEventListener('click', closeQuote);
        });
        if (quoteModal.openBtns && quoteModal.openBtns.length) {
          quoteModal.openBtns.forEach(function (btn) {
            btn.addEventListener('click', openQuote);
          });
        }
        if (quoteModal.form) {
          quoteModal.form.addEventListener('submit', submitQuote);
        }
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !quoteModal.el.hidden) closeQuote();
        });
      }
      function closeQuote() {
        if (!quoteModal.el) return;
        quoteModal.el.hidden = true;
        document.body.style.overflow = '';
        if (quoteModal.status) { quoteModal.status.hidden = true; quoteModal.status.className = 'lemust-quote__status'; }
      }
      function openQuote() {
        if (!quoteModal.el) return;
        // Collecte des lignes actives
        var totalPots = 0, totalCartons = 0, totalAmount = 0;
        var bodyLines = [];
        var packingHtml = '<h4 class="lemust-quote__packing-title">Récapitulatif de la demande</h4>';
        var byGamme = {};

        rows.forEach(function (row) {
          var stepper = row.querySelector('[data-stepper]');
          var step = parseInt(stepper.dataset.step, 10) || 0;
          if (step <= 0) return;
          var mix = stepToVariantMix(step);
          var p16 = parseInt(row.dataset.p16Cents, 10) || 0;
          var p48 = parseInt(row.dataset.p48Cents, 10) || 0;
          var u = readUnits(row);
          var pots = stepToPots(step, u.small, u.large);
          var lineTotal = mix.v16qty * p16 + mix.v48qty * p48;
          var cartonsQty = mix.v16qty + mix.v48qty;

          var gammeKey   = row.dataset.gammeKey || 'x';
          var gammeBlock = root.querySelector('[data-gamme-block][data-gamme-key="' + gammeKey + '"]');
          var gammeLabel = gammeBlock ? (gammeBlock.dataset.gammeLabel || 'Gamme') : 'Gamme';

          if (!byGamme[gammeKey]) byGamme[gammeKey] = { label: gammeLabel, items: [] };

          if (mix.v16qty > 0) {
            byGamme[gammeKey].items.push({
              qty: mix.v16qty, format: 'Carton de ' + u.small, name: row.dataset.productTitle,
              lineTotal: mix.v16qty * p16
            });
          }
          if (mix.v48qty > 0) {
            byGamme[gammeKey].items.push({
              qty: mix.v48qty, format: 'Carton de ' + u.large, name: row.dataset.productTitle,
              lineTotal: mix.v48qty * p48
            });
          }
          totalPots += pots;
          totalCartons += cartonsQty;
          totalAmount += lineTotal;
        });

        Object.keys(byGamme).forEach(function (key) {
          var g = byGamme[key];
          bodyLines.push('--- ' + g.label + ' ---');
          g.items.forEach(function (it) {
            packingHtml +=
              '<div class="lemust-quote__packing-line">' +
                '<span><strong>×' + it.qty + '</strong> ' + escapeHtml(it.format) + ' — ' + escapeHtml(it.name) + '</span>' +
                '<span>' + fmt.format(it.lineTotal / 100) + '</span>' +
              '</div>';
            bodyLines.push('  ' + it.qty + ' × ' + it.format + ' — ' + it.name + ' — ' + fmt.format(it.lineTotal / 100));
          });
        });
        packingHtml +=
          '<div class="lemust-quote__packing-total">' +
            '<span>Total HT estimé (' + totalCartons + ' cartons · ' + totalPots + ' pots)</span>' +
            '<span>' + fmt.format(totalAmount / 100) + '</span>' +
          '</div>';

        // Numero TVA si case cochee
        var vatValue = '';
        if (businessToggle && businessToggle.checked && vatInput) {
          vatValue = vatInput.value.trim();
          if (vatValue) {
            packingHtml +=
              '<div class="lemust-quote__packing-vat">' +
                '<span>Numéro de TVA</span>' +
                '<strong>' + escapeHtml(vatValue) + '</strong>' +
              '</div>';
            bodyLines.push('');
            bodyLines.push('Numéro de TVA : ' + vatValue);
          }
        }

        // Remplit la modale
        if (quoteModal.packing) quoteModal.packing.innerHTML = packingHtml;
        if (quoteModal.body)    quoteModal.body.value = bodyLines.join('\n') + '\n\nTotal : ' + totalCartons + ' cartons · ' + totalPots + ' pots · ' + fmt.format(totalAmount / 100) + ' HT';
        if (quoteModal.vat)     quoteModal.vat.value = vatValue;
        if (quoteModal.total)   quoteModal.total.value = fmt.format(totalAmount / 100);
        if (quoteModal.pots)    quoteModal.pots.value = totalPots;
        if (quoteModal.cartons) quoteModal.cartons.value = totalCartons;

        quoteModal.el.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      function submitQuote(e) {
        e.preventDefault();
        if (!quoteModal.form) return;
        quoteModal.submit.disabled = true;
        var origLabel = quoteModal.submit.textContent;
        quoteModal.submit.textContent = 'Envoi en cours...';
        if (quoteModal.status) { quoteModal.status.hidden = true; quoteModal.status.className = 'lemust-quote__status'; }

        var fd = new FormData(quoteModal.form);
        fetch(quoteModal.form.getAttribute('action'), {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'text/html' }
        })
        .then(function (res) {
          if (res.ok || res.status === 302 || (res.status >= 200 && res.status < 400)) {
            if (quoteModal.status) {
              quoteModal.status.hidden = false;
              quoteModal.status.classList.add('is-success');
              quoteModal.status.textContent = '✓ Votre demande a bien été envoyée. Nous vous répondons sous 24-48h.';
            }
            quoteModal.submit.textContent = '✓ Envoyée';
            // Reset form apres 2.5s puis ferme
            setTimeout(function () {
              quoteModal.form.reset();
              closeQuote();
              quoteModal.submit.disabled = false;
              quoteModal.submit.textContent = origLabel;
            }, 2500);
          } else {
            throw new Error('HTTP ' + res.status);
          }
        })
        .catch(function (err) {
          console.error('[Lemust] Envoi devis echoue', err);
          if (quoteModal.status) {
            quoteModal.status.hidden = false;
            quoteModal.status.classList.add('is-error');
            quoteModal.status.textContent = 'Une erreur est survenue. Merci de réessayer ou de nous contacter directement.';
          }
          quoteModal.submit.disabled = false;
          quoteModal.submit.textContent = origLabel;
        });
      }

      // ============================================================
      // PACKING LIST : modale recapitulative avant checkout
      // ============================================================
      function initPackingModal() {
        if (!packingModal.el) return;
        packingModal.el.querySelectorAll('[data-packing-close]').forEach(function (el) {
          el.addEventListener('click', closePacking);
        });
        if (packingModal.confirmBtn) {
          packingModal.confirmBtn.addEventListener('click', confirmPackingList);
        }
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !packingModal.el.hidden) closePacking();
        });
      }
      function closePacking() {
        if (!packingModal.el) return;
        packingModal.el.hidden = true;
        document.body.style.overflow = '';
      }

      function openPackingList() {
        // Verif TVA si case entreprise cochee
        var biz = getBusinessAttributes();
        if (biz && !biz.valid) {
          if (vatInput) {
            vatInput.setAttribute('aria-invalid', 'true');
            vatInput.focus();
          }
          if (sidebar.toast) {
            sidebar.toast.hidden = false;
            sidebar.toast.style.background = '#A73838';
            sidebar.toast.textContent = biz.error;
            setTimeout(function () { sidebar.toast.hidden = true; sidebar.toast.style.background = ''; }, 3500);
          }
          return;
        }
        if (vatInput) vatInput.removeAttribute('aria-invalid');

        // Regroupement par gamme
        var byGamme = {}; // key -> { label, accent, threshold, items:[], pots, cartons, total }
        var items = [];
        var totalPots = 0, totalCartons = 0, totalAmount = 0;

        rows.forEach(function (row) {
          var stepper = row.querySelector('[data-stepper]');
          var step = parseInt(stepper.dataset.step, 10) || 0;
          if (step <= 0) return;
          var mix = stepToVariantMix(step);
          var p16 = parseInt(row.dataset.p16Cents, 10) || 0;
          var p48 = parseInt(row.dataset.p48Cents, 10) || 0;
          var u = readUnits(row);
          var pots = stepToPots(step, u.small, u.large);
          var lineTotal = mix.v16qty * p16 + mix.v48qty * p48;
          var cartonsQty = mix.v16qty + mix.v48qty;

          var gammeKey   = row.dataset.gammeKey || 'x';
          var gammeBlock = root.querySelector('[data-gamme-block][data-gamme-key="' + gammeKey + '"]');
          var gammeLabel = gammeBlock ? (gammeBlock.dataset.gammeLabel || 'Gamme') : 'Gamme';
          var accent     = gammeBlock ? (gammeBlock.style.getPropertyValue('--gamme-accent').trim() || '#231f21') : '#231f21';
          var threshold  = gammeBlock ? (parseInt(gammeBlock.dataset.paletteThreshold, 10) || 0) : 0;

          if (!byGamme[gammeKey]) {
            byGamme[gammeKey] = {
              label: gammeLabel, accent: accent, threshold: threshold,
              items: [], pots: 0, cartons: 0, total: 0
            };
          }
          byGamme[gammeKey].pots    += pots;
          byGamme[gammeKey].cartons += cartonsQty;
          byGamme[gammeKey].total   += lineTotal;

          var rowImg = row.querySelector('.lemust-row__img');
          var imgSrc = rowImg ? rowImg.getAttribute('src') : '';
          if (mix.v16qty > 0) {
            byGamme[gammeKey].items.push({
              qty: mix.v16qty, format: 'Carton de ' + u.small, name: row.dataset.productTitle,
              lineTotal: mix.v16qty * p16, img: imgSrc
            });
            items.push({ id: parseInt(row.dataset.v16Id, 10), quantity: mix.v16qty });
          }
          if (mix.v48qty > 0) {
            byGamme[gammeKey].items.push({
              qty: mix.v48qty, format: 'Carton de ' + u.large, name: row.dataset.productTitle,
              lineTotal: mix.v48qty * p48, img: imgSrc
            });
            items.push({ id: parseInt(row.dataset.v48Id, 10), quantity: mix.v48qty });
          }

          totalPots    += pots;
          totalCartons += cartonsQty;
          totalAmount  += lineTotal;
        });

        if (!items.length) return;

        // Construction du corps de la modale
        packingModal.body.innerHTML = '';
        Object.keys(byGamme).forEach(function (key) {
          var g = byGamme[key];
          var block = document.createElement('div');
          block.className = 'lemust-packing__gamme';
          block.style.setProperty('--gamme-accent', g.accent);

          var head = document.createElement('div');
          head.className = 'lemust-packing__gamme-head';
          var pal = '';
          if (g.threshold > 0) {
            var nbPalettes = Math.floor(g.pots / g.threshold);
            var restePots  = g.pots - (nbPalettes * g.threshold);
            if (nbPalettes >= 1) {
              pal = ' · ' + nbPalettes + ' palette' + (nbPalettes > 1 ? 's' : '') +
                    (restePots > 0 ? ' + ' + restePots + ' pot' + (restePots > 1 ? 's' : '') : ' complète' + (nbPalettes > 1 ? 's' : ''));
            }
          }
          head.innerHTML =
            '<span class="lemust-packing__gamme-name">' + escapeHtml(g.label) + '</span>' +
            '<span class="lemust-packing__gamme-meta">' + g.cartons + ' carton' + (g.cartons > 1 ? 's' : '') + ' · ' + g.pots + ' pot' + (g.pots > 1 ? 's' : '') + escapeHtml(pal) + '</span>';
          block.appendChild(head);

          g.items.forEach(function (it) {
            var line = document.createElement('div');
            line.className = 'lemust-packing__item';
            var imgHtml = it.img
              ? '<img class="lemust-packing__item-img" src="' + escapeHtml(it.img) + '" alt="" loading="lazy">'
              : '<span class="lemust-packing__item-img lemust-packing__item-img--empty"></span>';
            line.innerHTML =
              imgHtml +
              '<span class="lemust-packing__item-qty">×' + it.qty + '</span>' +
              '<div class="lemust-packing__item-name">' +
                '<strong>' + escapeHtml(it.name) + '</strong>' +
                '<span class="lemust-packing__item-format">' + escapeHtml(it.format) + '</span>' +
              '</div>' +
              '<span class="lemust-packing__item-price">' + fmt.format(it.lineTotal / 100) + '</span>';
            block.appendChild(line);
          });

          packingModal.body.appendChild(block);
        });

        // Bloc palette global : agrege les palettes de toutes les gammes
        var totalPalettes = 0;
        var paletteBreakdown = [];
        Object.keys(byGamme).forEach(function (key) {
          var g = byGamme[key];
          if (g.threshold > 0) {
            var n = Math.floor(g.pots / g.threshold);
            if (n >= 1) {
              totalPalettes += n;
              paletteBreakdown.push(n + ' × ' + g.label);
            }
          }
        });
        if (totalPalettes > 0 && packingModal.palette) {
          packingModal.palette.hidden = false;
          if (packingModal.paletteT) packingModal.paletteT.textContent = totalPalettes + ' palette' + (totalPalettes > 1 ? 's' : '') + ' de livraison';
          if (packingModal.paletteD) packingModal.paletteD.textContent = paletteBreakdown.join(' · ') + ' · reste livré en cartons';
        } else if (packingModal.palette) {
          packingModal.palette.hidden = true;
        }

        // Bloc entreprise (si TVA)
        if (biz && biz.valid && packingModal.business) {
          packingModal.business.hidden = false;
          if (packingModal.vat) packingModal.vat.textContent = biz.attributes['Numéro de TVA'];
        } else if (packingModal.business) {
          packingModal.business.hidden = true;
        }

        // Totaux
        if (packingModal.pots)    packingModal.pots.textContent = totalPots;
        if (packingModal.cartons) packingModal.cartons.textContent = totalCartons;
        if (packingModal.total)   packingModal.total.textContent = fmt.format(totalAmount / 100);

        // Sauvegarde l'etat pour la confirmation
        packingCurrent = { items: items, biz: biz };

        // Affiche la modale
        packingModal.el.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      function confirmPackingList() {
        if (!packingCurrent) return;
        var items = packingCurrent.items;
        var biz   = packingCurrent.biz;

        packingModal.confirmBtn.disabled = true;
        packingModal.confirmBtn.textContent = 'Ajout en cours...';
        sidebar.addBtn.disabled = true;
        sidebar.addBtn.textContent = 'Ajout en cours...';
        // "Confirmer la commande" force le checkout direct
        var redirectMode = 'checkout';

        // Envoi des attributes (TVA) avant l'ajout
        var attrsPromise = Promise.resolve();
        if (biz && biz.valid) {
          attrsPromise = fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: biz.attributes })
          }).catch(function (e) { console.warn('[Lemust] Cart attributes failed', e); });
        }

        attrsPromise
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function () {
          if (redirectMode === 'cart')     { window.location.href = '/cart'; return null; }
          if (redirectMode === 'checkout') { window.location.href = '/checkout'; return null; }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          var selectors = [
            '[data-cart-count]', '[data-cart-item-count]', '.cart-count',
            '.cart-count-bubble', '.cart-icon__bubble', '.js-cart-count'
          ];
          selectors.forEach(function (sel) {
            document.querySelectorAll(sel).forEach(function (el) {
              el.textContent = cart.item_count;
              if (el.dataset) el.dataset.count = cart.item_count;
              if (cart.item_count > 0) el.hidden = false;
            });
          });
          ['cart:added', 'cart:updated', 'cart:refresh', 'cart:change', 'cart-drawer:refresh'].forEach(function (evt) {
            document.dispatchEvent(new CustomEvent(evt, { detail: { cart: cart }, bubbles: true }));
          });
          var drawer = document.querySelector('cart-drawer, [is="cart-drawer"], #cart-drawer, .cart-drawer, [data-cart-drawer]');
          if (drawer && typeof drawer.open === 'function') {
            try { drawer.open(); } catch (_) {}
          }
          sidebar.addBtn.textContent = '✓ Ajouté au panier';
          clearAllSelection();
          clearSelectionStorage();
          closePacking();
          if (packingModal.confirmBtn) {
            packingModal.confirmBtn.disabled = false;
            packingModal.confirmBtn.innerHTML = 'Confirmer et passer commande <svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M9.29 6.71a1 1 0 000 1.41L13.17 12l-3.88 3.88a1 1 0 001.41 1.41l4.59-4.59a1 1 0 000-1.41L10.7 6.71a1 1 0 00-1.41 0z"/></svg>';
          }
          setTimeout(function () {
            sidebar.addBtn.textContent = 'Ajouter au panier';
            sidebar.addBtn.disabled = false;
          }, 2200);
        })
        .catch(function (err) {
          console.error('[Lemust] Ajout panier echoue', err);
          sidebar.addBtn.textContent = 'Erreur, réessayer';
          if (packingModal.confirmBtn) {
            packingModal.confirmBtn.disabled = false;
            packingModal.confirmBtn.textContent = 'Erreur, réessayer';
          }
          setTimeout(function () {
            sidebar.addBtn.textContent = 'Ajouter au panier';
            sidebar.addBtn.disabled = false;
            if (packingModal.confirmBtn) {
              packingModal.confirmBtn.innerHTML = 'Confirmer et passer commande <svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M9.29 6.71a1 1 0 000 1.41L13.17 12l-3.88 3.88a1 1 0 001.41 1.41l4.59-4.59a1 1 0 000-1.41L10.7 6.71a1 1 0 00-1.41 0z"/></svg>';
            }
          }, 2500);
        });
      }

      function escapeHtml(s) {
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
